/**
 * Retorna variable por modulo
 */
export const mensajes = {
  header: {
    titulo: "Salud en Casa",
  },

  inicio: {
    err: {
      fueraDeServicio:
        "En este momento el sistema no se encuentra disponible por favor intente mas tarde",
      guardarRemision:
        "Ocurrio un error gaurdando la remisión vuelve a intentar de nuevo",
    },
    success: {
      guardarRemision: "Se ha guardado la remisión correctamente",
      enviarRemision: "La Remisión fue enviada a Admisiones exitosamente",
      admitirRemision: "Se admitio la remisón correctamente",
      cancelarRemision: "Se cancelo la remisión",
      noAdmitirRemision: "No se admitio la remisión",
    },
  },

  menu: {
    inicio: "Inicio",
    remision: "Remisión",
    crear: "Crear",
    listarRemision: "Listar Remisiones",
    listarSolicitud: "Listar Solicitudes",
    novedad: "Novedad",
    lineaUnica: "Línea Única",
    gestionarNovedades: "Gestionar Novedades",
    gestionarPacientes: "Gestionar Pacientes",
    historialPlanManejo: "Plan de manejo",
    listaLineaUnica: "Lista",
    consultaCitaLineaUnica: "Consulta de citas",
    equiposBiomedicos: "Equipos Biomédicos",
    historialGestionEquiposBiomedicos: "Historial y Gestión",
    accesoBiomedicos: "Gestionar Acceso",
    ambulatorio: "Ambulatorio",
    bebecanguro: "Remisiones Bebé Canguro",
    aplicacionMedicamentos: "Remisiones de Medicamentos",
    transporte: "Transporte",
    informeVehicular: "Informe Vehicular",
    informeRemisiones: "Informe Remisiones",
    bandejaDinamica: "Bandeja Dinámica",
    historialGestionBandejaDinamica: "Historial y Gestión",
    seguridad: "Seguridad",
    oncor: "Información Seguridad",
    Administracion: "Administración",
    gestionProveedores: "Gestión Proveedores",
    gestionProfesionales: "Gestion Profesionales",
    gestionMaestros: "Gestionar Maestros",
    solicitudNH: "Solicitudes",
    informes: {
      title: "Informes",
      consultaMedicamentos: "Consulta de Medicamentos",
      estadosLogistico: "Estados Logisticos",
      curaciones: "Curaciones",
      egresos: "Egresos",
      aplicacionMedicamentos: "Apicación Medicamentos por Cuidador",
      accesosCentrales: "Accesos Centrales",
      logisticoGestor: "Logístico del Gestor",
    },
    pager: "Pager",
    maestros: "Control Maestros",
    calendarios: "Calendarios",
  },

  gestionMaestros: {
    title: "Gestión de Maestros",
    maestro: "Maestro",
    tablaMaestros: {
      listaMaestros: {
        //Falta Implementar entity y visual

        sedesSaludEnCasa: "SedesSaludEnCasa",
        novedadesPorTipoAdmision: "NovedadesPorTipoAdmision",
        permisosTerceros: "PermisosTerceros",

        //////Faltan en el back
        centroEstadiaTemporal: "CentroEstadiaTemporal",
        motivoEgreso: "MotivoEgreso",
        profesional: "Profesional",
        tipoSondajeNovedades: "TipoSondajeNovedades",
        validacionOPC: "ValidacionOPC",
        tiposPlanParticular: "TiposPlanParticular",
        ////////////////////

        causasLlamadaNoContestada: "CausasLlamadaNoContestada",
        ciudad: "Ciudad",
        diagnostico: "Diagnostico",
        tipoSondajeIngreso: "TipoSondajeIngreso",
        dosis: "Dosis",
        estadoPaciente: "EstadoPaciente",
        motivoAplicacionCuidador: "MotivoAplicacionCuidador",
        motivoFijarCita: "MotivoFijarCita",
        proveedor: "Proveedor",
        tipoCuracion: "TipoCuracion",
        tipoEquipoBiomedico: "TipoEquipoBiomedico",
        tipoMuestra: "TipoMuestra",
        tipoTerapia: "TipoTerapia",
        frecuencia: "Frecuencia",
        institucion: "Institucion",
        medicamento: "Medicamento",
        motivoCancelacion: "MotivosNoAdmision",
        municipio: "Municipio",
        piso: "Piso",
        planSalud: "PlanSalud",
        tipoNutricion: " TipoNutricion",
        tiposIdentificacion: "TiposIdentificacion",
        tipoSoporteNutricional: "TipoSoporteNutricional",
        viaAdministracion: "ViaAdministracion",
        programa: "Programa",
        valoraciones: "Valoraciones",
      },
      title: "Maestro ",
      agregar: "Agregar ",
      accion: "Acciones",
      totalRegistros: "Total Registros",
      acciones: {
        editar: "Editar",
        eliminar: "Eliminar",
      },
    },
    lista: {
      causasLlamadaNoContestada: "Causas de Llamada No Contestada",
      ciudad: "Ciudad",
      diagnostico: "Diagnóstico",
      tipoSondajeIngreso: "Tipo de Sondaje Ingreso",
      dosis: "Dosis",
      estadoPaciente: "Estado del Paciente",
      motivoAplicacionCuidador: "Motivo de Aplicacion Cuidador",
      motivoFijarCita: "Motivo Fijar Cita",
      novedadesPorTipoAdmision: "Novedades Por Tipo Admision",
      permisosTerceros: "Permisos de Terceros",
      proveedor: "Proveedor",
      tipoCuracion: "Tipo Curacion",
      tipoEquipoBiomedico: "Tipo EquipoBiomedico",
      tipoMuestra: "Tipo Muestra",
      tipoTerapia: "Tipo Terapia",
      frecuencia: "Frecuencia",
      institucion: "Institucion",
      medicamento: "Medicamento",
      motivoCancelacion: "Motivo Cancelacion",
      municipio: "Municipio",
      piso: "Piso",
      planSalud: "Plan de Salud",
      tipoNutricion: " Tipo de Nutricion",
      tiposIdentificacion: "Tipos de Identificacion",
      tipoSoporteNutricional: "Tipo de Soporte Nutricional",
      viaAdministracion: "Via de Administracion",
      tiposPlanParticular: "Tipos Plan Particular",
      programa: "Programa",
      valoraciones: "Valoraciones",
      centroEstadiaTemporal: "Centro de Estadia Temporal",
      motivoEgreso: "Motivo Egreso",
      profesional: "Profesional",
      sedesSaludEnCasa: "Sedes Salud En Casa",
      tipoSondajeNovedades: "Tipo Sondaje Novedades",
      validacionOPC: "Validacion OPC",
    },
    modal: {
      editar: "Editar ",
      crear: "Crear ",
      errores: {
        requerido: "Este campo es requerido",
      },
      botones: {
        guardar: "Guardar",
        cancelar: "Cancelar",
      },
    },
  },

  maestros: {
    totalRegistros: "Total registros: ",
    botones: {
      guardar: "Guardar",
      cancelar: "Cancelar",
      editar: "Editar",
    },
    errores: {
      ciudadRequerido: "Seleccione la ciudad",
      nombreRequerido: "Ingresa nombre",
    },
    lista: {
      institucion: "INSTITUCIONES",
      ciudad: "CIUDADES",
      soporteNutricional: "TIPO_SOPORTE_NUTRICIONAL",
      diagnosticos: "DIAGNOSTICOS",
      diagnosticosEspeciales: "DIAGNOSTICOS_ESPECIALES",
      programas: "PROGRAMAS",
      usuarios: "USUARIOS",
      motivoEgreso: "MOTIVO_EGRESO",
      motivoCancelacion: "MOTIVO_CANCELACION",
      tipoCasoCovid: "TIPO_CASO_COVID",
    },
    tituloVentana: {
      agregarEditarInstituciones: "Agregar / Editar Instituciones",
      agregarEditarTiposIdentificacion:
        "Agregar / Editar Tipos de Identificacion",
      agregarEditarTipoSoporteNutricional:
        "Agregar / Editar Tipo de Soporte Nutricional",
      agregarEditarDiagnosticos: "Agregar / Editar Diagnosticos",
      agregarEditarDiagnosticosEspeciales:
        "Agregar / Editar Diagnosticos Especiales",
      agregarEditarProgramas: "Agregar / Editar Programas",
      agregarEditarUsuarios: "Agregar / Editar Usuarios",
      agregarEditarMotivoEgreso: "Agregar / Editar Motivo Egreso",
      agregarEditarMotivoCancelacion: "Agregar / Editar Motivo Cancelacion",
      agregarEditarTipoCasoCovid: "Agregar / Editar Tipo Caso Covid",
    },
    campos: {
      nombreInstitucion: "Nombre Institucion",
      ciudad: "Ciudad",
    },
    tabla: {
      tituloEliminarInstitucion: "Eliminar institucion",
      contenidoEliminarInstitucion: "¿Está seguro de eliminar la institucion?",
      tituloEliminarTipoSoporteNutricional: "Eliminar Soporte Nutricional",
      contenidoEliminarTipoSoporteNutricional:
        "¿Está seguro de eliminar el soportre nutricional?",
      tituloEliminarDiagnostico: "Eliminar Diagnostico",
      contenidoEliminarDiagnostico: "¿Está seguro de eliminar el diagnostico?",
      tituloEliminarDiagnosticoEspecial: "Eliminar Diagnostico Especial",
      contenidoEliminarDiagnosticoEspecial:
        "¿Está seguro de eliminar el diagnostico especial?",
      tituloEliminarPrograma: "Eliminar Programa",
      contenidoEliminarPrograma: "¿Está seguro de eliminar el programa?",
      tituloEliminarUsuario: "Eliminar usuario",
      contenidoEliminarUsuario: "¿Está seguro de eliminar el usuario?",
      tituloEliminarMotivoEgreso: "Eliminar Motivo Egreso",
      contenidoEliminarMotivoEgreso:
        "¿Está seguro de eliminar el Motivo Egreso?",
    },

    instituciones: {
      campos: {
        nombre: "Nombre",
        ciudad: "Ciudad",
      },
      errores: {
        nombreRequerido: "Ingrese nombre",
        ciudadRequerido: "Seleccione la ciudad",
      },
      tabla: {
        nombreCampo: "Nombre",
        nombre: "Nombre",
        ciudadCampo: "Ciudad",
        ciudad: "Ciudad",
        accion: "Accion",
        noInstituiones: "No se han agregado instituciones",
      },
    },

    ciudades: {
      campos: {
        nombre: "Nombre",
        direccion: "Direccion",
      },
      errores: {
        nombreRequerido: "Ingrese nombre",
        direccionRequerido: "Ingrese la direccion",
      },
      tabla: {
        nombreCampo: "Nombre",
        nombre: "Nombre",
        direccionCampo: "Direccion",
        direccion: "Direccion",
        accion: "Accion",
        noCiudades: "No se han agregado ciudades",
      },
    },

    tipoSoporteNutricional: {
      campos: {
        nombre: "Nombre",
        direccion: "Direccion",
      },
      errores: {
        nombreRequerido: "Ingrese nombre",
        direccionRequerido: "Ingrese la direccion",
      },
      tabla: {
        descripcionCampo: "Nombre",
        descripcion: "Nombre",
        accion: "Accion",
        noCiudades: "No se han agregado ciudades",
      },
    },

    diagnosticos: {
      campos: {
        codigo: "Codigo",
        nombre: "Nombre",
      },
      errores: {
        codigoRequerido: "Ingrese codigo",
        nombreRequerido: "Ingrese nombre",
      },
      tabla: {
        codigoCampo: "Codigo",
        codigo: "Codigo",
        nombreCampo: "Nombre",
        nombre: "Nombre",
        accion: "Accion",
        noDiagnosticos: "No se han agregado diagnosticos",
      },
    },

    diagnosticosEspeciales: {
      campos: {
        nombre: "Codigo",
        direccion: "Nombre",
      },
      errores: {
        codigoRequerido: "Ingrese codigo",
        nombreRequerido: "Ingrese nombre",
      },
      tabla: {
        codigoCampo: "Codigo",
        codigo: "Codigo",
        nombreCampo: "Nombre",
        nombre: "Nombre",
        accion: "Accion",
        noCiudades: "No se han agregado diagnosticos",
      },
    },

    programas: {
      campos: {
        numero: "Numero de programa",
        nombre: "Nombre",
        especialidad: "Especialidad",
        profesional: "Profesional",
      },
      errores: {
        nombreRequerido: "Ingrese nombre",
        ciudadRequerido: "Seleccione la ciudad",
      },
      tabla: {
        numeroProgramaCampo: "Numero Programa",
        numeroPrograma: "Numero Programa",
        nombreCampo: "Nombre",
        nombre: "Nombre",
        especialidadCampo: "Especialidad",
        especialidad: "Especialidad",
        profesionalCampo: "Profesional",
        profesional: "Profesional",
        citaAutomaticaCampo: "Cita Automatica",
        citaAutomatica: "Cita Automatica",
        accion: "Accion",
        noProgramas: "No se han agregado programas",
      },
    },

    usuarios: {
      campos: {
        nombre: "Nombre",
      },
      errores: {
        nombreRequerido: "Ingrese nombre de usuario",
      },
      tabla: {
        nombreCampo: "Nombre",
        nombre: "Nombre",
        accion: "Accion",
        noUsuarios: "No se han agregado Usuarios",
      },
    },

    motivoEgreso: {
      campos: {
        nombre: "Nombre",
      },
      errores: {
        nombreRequerido: "Ingrese nombre",
      },
      tabla: {
        nombreCampo: "Nombre",
        nombre: "Nombre",
        accion: "Accion",
        noMotivoEgreso: "No se han agregado motivo egresos",
      },
    },
  },

  menuAdministrativo: {
    gestionProveedores: {
      opcionesMenu: {
        proveedores: "Proveedores",
        gestionAcceso: "Gestion Acesso",
      },
      tabla: {
        nombreCampo: "Nombre",
        nombre: "Nombre",
        correoCampo: "Correo",
        correo: "Correo",
        estadoCampo: "Estado",
        estado: "Estado",
        accionCampo: "Acción",
        accion: "Acción",
        totalRegistros: "Total registros: ",
        noProveedores: "No se han agregado proveedores",
      },
      modalProveedor: {
        botones: {
          cancelar: "Cancelar",
          guardar: "Guardar",
        },
        errores: {
          nombreProveedorRequerido: "Ingrese nombre proveedor",
          emailRequerido: "Ingrese Correo electrónico",
          emailInvalido: "Correo electrónico invalido",
        },
        campos: {
          nombreProveedor: "Nombre proveedor",
          emailProveedor: "Email",
        },

        tipoAccion: {
          agregar: "Agregar",
          editar: "Editar",
        },
      },
    },
    gestionProfesionales: {
      tabla: {
        nombreCampo: "Nombre",
        nombre: "Nombre",
        correoCampo: "Correo",
        correo: "Correo",
        identificacionCampo: "Identificación",
        identificacion: "Identificación",
        regionCampo: "Región",
        region: "Región",
        accionCampo: "Acción",
        accion: "Acción",
        totalRegistros: "Total registros: ",
        noProfesionales: "No se han encontrado profesionales",
      },
      modalProfesional: {
        botones: {
          cancelar: "Cancelar",
          guardar: "Guardar",
        },
        errores: {
          numeroDocumentoProfesionalRequerido:
            "Ingrese un numero de documento valido",
        },
        campos: {
          nombreProfesional: "Nombre profesional",
          documentoProfesional: "numero documento",
          nombre: "Profesional",
        },
        tipoAccion: {
          agregar: "Agregar",
          editar: "Editar",
        },
        mensajesAlerta: {
          tituloConfirmarCambioNumero: "¿Actualizar número de identificación?",
          contenidoConfirmarCambioNumero:
            "Al realizar esta acción se actualizará el número de identificación en ClickSoftware y en las citas que el profesional tenga asignadas.",
          exitoGestionarEquipo:
            "Se ha gestionado el equipo biomédico exitosamente",
          errorGestionarEquipo: "Ha ocurrido un error, favor intente más tarde",
        },
      },
    },
  },

  resultadoBusqueda: {
    numeroRegistros: "Número de registros: ",
    buscar: "Buscar",
  },

  modalConfirmacion: {
    botones: {
      aceptar: "Aceptar",
      cancelar: "Cancelar",
    },
  },

  modalHorarioDisponible: {
    botones: {
      agendarCitaYadmitir: "Agendar y Admitir",
    },
    tabla: {
      profesionalCampo: "Profesional",
      profesional: "Profesional",
      inicioCitaCampo: "Inicio",
      inicioCita: "Inicio",
      finCitaCampo: "Fin",
      finCita: "Fin",
    },
  },

  modalCargarArchivos: {
    botones: {
      cerrar: "Cerrar",
      cargar: "Cargar",
      cancelar: "Cancelar",
    },
    opciones: {
      cargarAnexos: "Cargar anexo",
      descargarAnexos: "Descargar anexos",
    },
    titulo: {
      anexos: "Anexos",
      archivoSeleccionado: "Archivo seleccionado :",
    },
    tabla: {
      documentosCampo: "Documentos",
      documento: "Documentos",
      accion: "Accion",
      totalRegistros: "Total registros",
      message: "El paciente no tiene archivos anexados",
    },
  },

  remisionContenedor: {
    pasos: {
      datosPaciente: "Datos de paciente",
      datosAtencion: "Datos de atención",
      diagnostico: "Diagnóstico",
      datosRemision: "Datos de remisión",
      planManejo: "Plan de manejo",
      admision: "Admisión",
    },
  },

  acciones: {
    numeroRemision: "Número remisión:",
    estadoRemision: "Estado remisión:",
    nombre: "Nombre: ",
    tipoAsegurador: "Tipo Asegurador",
    tipoAfiliacion: "Tipo Afiliación",
    edad: "Edad",
    sexo: "Sexo",
    guardar: "Guardar",
    enviar: "Enviar",
    cancelar: "Cancelar remisión",
    crearPaciente: "Crear paciente",
    cargarAnexos: "Cargar anexos",
    anexos: "Anexos",
    consultarAnexos: "Consultar anexos",
    consentimiento: "Consentimiento",
    imprimir: "Imprimir",
    nombreArchivoConsentimiento: "Consentimiento.pdf",
    errorConsentimiento: "Ha ocurrido un error",
    errorConsentimientoFaltanDatos: "Faltan datos por ingresar",
    errorRemisionReport: "El numero de la remision no existe",
    nombreArchivoRemision: "Remision.pdf",
    mensajeErrorCargarUsuario:
      "Ha ocurrido un error al guardar, favor contactar a soporte",
    tituloCancelacion: "Información de cancelación",
    tituloNoAdmision: "Información de no admisión",
    motivoCierre: "Motivo",
    observacionCierre: "Observación",
    usuarioCierre: "Usuario",
    fechaCierre: "Fecha",
  },

  comunes: {
    diasSemana: {
      idLunes: "2",
      lunes: "Lunes",
      idMartes: "3",
      martes: "Martes",
      idMiercoles: "4",
      miercoles: "Miercoles",
      idJueves: "5",
      jueves: "Jueves",
      idViernes: "6",
      viernes: "Viernes",
      idSabado: "7",
      sabado: "Sábado",
      idDomingo: "1",
      domingo: "Domingo",
    },
  },

  datosPaciente: {
    campos: {
      tipo: "Tipo identificación",
      numero: "Número identificación",
      planSalud: "Plan de salud",
      codigoAutorizacion: "Código de autorización",
      codigoSiniestro: "Código siniestro",
      tipoPlanSalud: "Tipo plan de salud",
      idTipoPlanSaludArl: "7",
      idTipoPlanSaludParticular: "3",
      esNoHospitalario: "NoHospitalario",
      esHospitalario: "Hospitalario",
      nombres: "Nombres del paciente",
      apellidos: "Apellidos del paciente",
      sexo: "Sexo del paciente*",
      estadoCivil: "Estado civil*",
      autoriza: "Nombre de quien autoriza",
      email: "Email",
    },
    botones: {
      buscar: "Buscar",
      sinCobertura: "No admitir",
      crearPaciente: "Crear Paciente",
      cancelar: "Cancelar",
    },
    errores: {
      numeroRequerido: "Ingresa el número",
      tipoRequerido: "Elige el tipo",
      planSaludRequerido: "Elige el plan",
      numeroMaximaLongitud: "Máximo 15 dígitos",
      numeroFormatoInvalido: "Número inválido",
      codigoInvalido: "Código inválido",
      codigoMaximaLongitud: "Máximo 15 dígitos",
      tipoPlanSaludRequerido: "Elige el tipo de plan",

      nombresRequerido: "Ingrese nombres",
      apellidosRequerido: "Ingrese apellidos",
      emailInvalido: "Email invalido",
      emailRequerido: "Ingrese email",
      sexoRequerido: "Elija una opcion",
      fechaRequerida: "Elija una fecha",
      estadoCivilRequerido: "Elija una opcion",
      autorizaRequerido: "Ingrese nombre",
      fechaNacimiento: "Ingrese fecha de nacimiento",
    },
    informacionPaciente: {
      titulo: "Información paciente",
      nombre: "Nombres y apellidos",
      fechaNacimiento: "Fecha de nacimiento",
      edad: "Edad",
      sexo: "Sexo",
      estadoCivil: "Estado civil",
      ocupacion: "Ocupación",
      email: "Email",
      tipoAsegurador: "Tipo de asegurador",
      estadoSuspension: "Estado de suspensión",
      coberturaDomiciliaria: "¿Cobertura hospitalización domiciliaria?",
      fechaLimiteCobertura: "Fecha límite de cobertura",
      tipoAfiliacion: "Tipo de afiliación",
      nivelIngreso: "Nivel de ingreso",
      ipsBasicaAsignada: "IPS básica asignada",
      lugarAtencion: "Lugar de atención",
      codigoARL: "Código de Autorización",
      priorizacion: "Prioridad",
      subNivel: "Sub Nivel",
      fechaInicioSintomas: "Fecha inicio síntomas",
      fechaConsultaMedica: "Fecha de consulta médica",
      fechaTomaMuestra: "Fecha de toma de muestra",
      tipoCasoCovid: "tipo de caso covid",
      embarazada: "¿Es gestante?",
      vacunacion: "Estado vacunación COVID",
    },
    bebeCanguro: {
      campos: {
        fechaNacimiento: "Fecha de nacimiento",
        pesoNacimiento: "Peso de nacimiento",
        edadGestacional: "Edad gestacional al nacimiento *",
        pesoAlta: "Peso al alta",
        semanas: "Semanas",
        dias: "Días",
        cantidad: "Cantidad",
        gramos: "gr",
      },
      errores: {
        fechaNacimientoRequerido: "Ingresa la fecha",
        pesoNacimientoRequerido: "Ingrese peso de nacimiento",
        pesoNacimientoInvalido: "Peso de nacimiento inválido",
        pesoNacimientoMinimoValor: "Peso mínimo de 800 gramos",
        edadGestacionalSemanasRequerido: "Ingrese las semanas",
        edadGestacionalSemanasInvalido: "Cantidad inválida",
        edadGestacionalSemanasMinimoValor: "Mínimo 28 semanas",
        edadGestacionalSemanasMaximoValor: "Máximo 41 semanas",
        edadGestacionalDiasRequerido: "Ingrese los días",
        edadGestacionalDiasInvalido: "Cantidad inválida",
        edadGestacionalDiasMinimoValor: "Mínimo 0 días",
        edadGestacionalDiasMaximoValor: "Máximo 6 días",
        pesoAltaRequerido: "Ingrese el peso al alta",
        pesoAltaInvalido: "Peso al alta inválido",
        pesoAltaMinimoValor: "Peso mínimo de 1000 gramos",
      },
      tabla: {
        fechaNacimientoCampo: "fechaNacimiento",
        fechaNacimiento: "Fecha nacimiento",
        pesoNacimientoCampo: "pesoNacimiento",
        pesoNacimiento: "Peso nacimiento",
        edadGestacionalSemanasCampo: "edadGestacionalSemanas",
        edadGestacionalSemanas: "Semanas de gestación",
        edadGestacionalDiasCampo: "edadGestacionalDias",
        edadGestacionalDias: "Días de gestación",
        pesoAltaCampo: "pesoAlta",
        pesoAlta: "Peso al alta",
        accion: "Acción",
        editar: "Editar",
        eliminar: "Eliminar",
        noBebeCanguro: "No se han agregado valoraciones de bebé canguro",
      },
      opcionesMenu: {
        bebeCanguro: "Bebé canguro",
      },
      titulos: {
        agregarEditarBebeCanguro: "Agregar / Editar Bebé canguro",
        tituloEliminarBebeCanguro: "Eliminar bebé canguro",
        contenidoEliminarBebeCanguro:
          "¿Está seguro de eliminar el bebé canguro?",
      },
      botones: {
        cancelar: "Cancelar",
        guardar: "Guardar",
        bebeCanguro: "Bebé canguro",
      },
    },
  },

  datosAtencion: {
    campos: {
      seleccionar: "Seleccionar",
      condicionesIngreso: "Condiciones de ingreso",
      condicionPacienteAcepta:
        "¿El paciente acepta voluntariamente la atención por Salud en Casa? *",
      condicionServicios:
        "¿Cuenta con agua potable, luz eléctrica, nevera y baño? *",
      servicioOxigenoAmbulatorio: "Remisión Ambulatoria de Oxígeno",
      si: "Sí",
      no: "No",
      esTomaMuestraAD: "Toma de muestra DX",
      ciudadPrincipal: "Ciudad principal",
      municipio: "Municipio",
      barrio: "Barrio",
      direccion: "Dirección atención",
      nombreCuidador: "Nombre cuidador",
      nombreResponsable: "Nombre responsable",
      telefonoPaciente: "Teléfono paciente",
      telefonoPacienteRequerido: "Teléfono paciente *",
      celularPaciente: "Celular 1",
      celularPaciente2: "Celular 2",
      celularPacienteRequerido: "Celular paciente *",
      agregarDireccion: "Agregar dirección",
      emailPaciente: "Email de paciente",
    },
    errores: {
      condicionPacienteAceptaRequerida: "Seleccione una opción",
      condicionServicioRequerida: "Seleccione una opción",
      ciudadPrincipalRequerida: "Elige la ciudad",
      barrioRequerido: "Elige el barrio",
      direccionRequerida: "Ingresa la dirección",
      direccionMaxLength: "La dirección superó el número máximo de caracteres",
      nombreCuidadorRequerido: "Ingresa el cuidador",
      nombreCuidadorMaximaLongitud: "Máximo 50 caracteres",
      nombreResponsableRequerido: "Ingresa el responsable",
      nombreResponsableMaximaLongitud: "Máximo 50 caracteres",
      telefonoRequerido: "Ingresa el teléfono",
      telefonoMaximaLongitud: "Máximo 7 dígitos",
      telefonoInvalido: "Teléfono inválido",
      celularRequerido: "Ingresa el celular",
      celularMaximaLongitud: "Máximo 10 dígitos",
      celularMinimaLongitud: "Deben ser 10 dígitos",
      celularInvalido: "Celular inválido",
      emailPacienteRequerido: "Ingresa el email",
      emailPacienteMaximaLongitud: "Máxima longitud 50 caracteres",
      emailPacienteInvalido: "Email inválido",
    },
    modalPacienteAcepta: {
      campos: {
        titulo: "Paciente no acepta atención",
        contenido:
          "El paciente no puede ser atendido por Salud en Casa. ¿Desea continuar y cerrar la remisión?",
      },
      botones: {
        continuar: "Continuar",
        cancelar: "Cancelar",
      },
    },
    modalDireccion: {
      campos: {
        ingresarDireccion: "Ingresar dirección",
        direccion: "Dirección",
        nombreLugar: "Nombre de la ubicación",
        tipoDeVia: "Tipo de via",
        informacion: "Información complementaria",
        descripcion: "Ej:urbanización, apartamento",
        seleccionar: "Seleccionar",
        municipio: "Municipio",
      },
      errores: {
        via: "Seleccione una vía",
        numerovia: "Ingresa un numero de calle",
        municipioRequerido: "Elige el municipio",
      },
    },
  },

  diagnosticos: {
    campos: {
      diagnostico: "Diagnóstico por el que se remite",
      buscar: "Buscar por código o nombre",
      eliminar: "Eliminar",
    },
    errores: {},
    tabla: {
      codigoCampo: "codigo",
      codigo: "Código",
      nombreCampo: "nombre",
      nombre: "Nombre",
      accion: "Acción",
      eliminar: "Eliminar",
      noDiagnosticos: "No se han agregado diagnósticos",
      totalRegistros: "Total registros: ",
    },
  },

  datosRemision: {
    campos: {
      institucion: "Institución que remite",
      telefono: "Teléfono de contacto",
      identificacionMedico: "Identificación médico *",
      tipoDocumentoMedico: "Tipo",
      numeroDocumentoMedico: "Número",
      nombreMedico: "Nombre médico",
      especialidadMedico: "Especialidad médico",
      emailContacto: "Email de contacto",
      resumenHistoriaClinica: "Resumen historia clínica",
      observaciones: "Observaciones",
      seleccionar: "Seleccionar",
      buscarProfesional: "Buscar profesional",
      peso: "Peso",
      medidaDePeso: "Medidas",
    },
    errores: {
      institucionRequerida: "Seleccione la institución",
      historiaClinica: "Historia clinica requerida",
      telefonoRequerido: "Ingresa el teléfono",
      telefonoMaximaLongitud: "Máxima longitud 10 dígitos",
      telefonoInvalido: "Teléfono inválido",
      tipoDocumentoMedicoRequerido: "Seleccione el tipo",
      numeroDocumentoMedicoRequerido: "Ingresa el número",
      numeroDocumentoMedicoMaximaLongitud: "Máxima longitud 20 dígitos",
      numeroDocumentoMedicoInvalido: "Número inválido",
      nombreMedicoRequerido: "Ingresa el nombre",
      nombreMedicoMaximaLongitud: "Máximo 50 caracteres",
      especialidadMedicoMaximaLongitud: "Máximo 50 caracteres",
      emailContactoRequerido: "Ingresa el email",
      emailContactoMaximaLongitud: "Máxima longitud 50 caracteres",
      emailContactoInvalido: "Email inválido",

      pesoRequerido: "Ingresa el peso",
      pesoFormatoInvalido: "Peso inválido",
      medidaPesoRequerido: "selecciona la medida",
    },
    modalRemisionCancela: {
      campos: {
        titulo: "Cancelar remisión",
        tituloNoAdmitir: "No admitir",
        contenido: "¿Desea continuar y cancelar la remisión?",
        motivoCancelacion: "Motivo de cancelación",
        observaciones: "Observaciones",
      },
      botones: {
        continuar: "Continuar",
        cancelar: "Cancelar",
      },
      errores: {
        motivoCancelacionRequerido: "Elige el motivo",
        numeroMaximaLongitud: "Máximo 4000 dígitos",
        mensajeErrorCargarUsuario:
          "Ha ocurrido un error al cancelar, favor contactar a soporte",
      },
    },
  },
  admisiones: {
    campos: {
      fechaAdmision: "Fecha de admisión",
      usuarioResponsable: "Usuario responsable:",
      empalme: "Empalme",
      fechaEmpalme: "Fecha de empalme:",
      tipoAtencion: "Tipo de atención: *",
      tipoAtencionAmbulatoria: "Ambulatorio",
      tipoAtencionDomiciliario: "Domiciliario",
      entregadoA: "Entregado a: *",
      seleccionar: "Seleccionar",
      piso: "Piso: *",
      sede: "Sede: *",
      programa: "Programa: *",
      gestionAdmision: "Gestión de la admisión:",
      estadiaTemporal:
        "El paciente requiere y acepta ser atendido en el Centro de Estadia Temporal (CET)",
      idSedeClinicaHeridas: "18",
      embarazada: "Embarazada",
      oxigenoDependiente: "Oxigeno Dependiente",
      tipoConvenio: "Seleccione tipo de convenio:"
    },
    botones: {
      admitir: "Admitir",
      empalme: "Empalme",
    },
    errores: {
      fechaEmpalme: "Seleccione una fecha para el Empalme",
      tipoAtencion: "Seleccione un tipo de atención",
      pisoAmbulatorio: "Seleccione un piso",
      sede: "Seleccione una sede",
      pisoDomiciliario: "Seleccione un piso",
      programa: "Seleccione un programa",
      tipoConvenio: "Seleccione un tipo de convenio",
      mensajeErrorCargarUsuario:
        "Ha ocurrido un error al admitir, favor contactar a soporte",
    },
    modalFechaPsoterior: {
      campos: {
        titulo: "Admitir remision",
        contenido:
          "¿Desea admitir la remisión con una fecha posterior a la de hoy?",
      },
      botones: {
        continuar: "Continuar",
        cancelar: "Cancelar",
      },
    },
    modalCentroEstadia: {
      campos: {
        titulo: "Centro de estadia temporal",
        contenido:
          "Si selecciona un centro de estadia personal cambiaran los datos de atención del paciente",
        seleccione: "SELECCIONAR",
      },
      botones: {
        continuar: "Continuar",
        cancelar: "Cancelar",
      },
      error: {
        errorAceptar: "Debes seleccionar un centro de estadia temporal",
      },
    },
  },

  listaRemision: {
    campos: {
      tipoDocumento: "Tipo documento",
      identificacion: "Identificación",
      remision: "Remisión",
      institucionRemitente: "Institución remitente",
      planSalud: "Plan de salud",
      estado: "Estado",
      usuario: "Usuario",
      ciudadPrincipal: "Ciudad principal",
      tipoAtencion: "Tipo atención",
      fechaInicioRemision: "Fecha Inicio Remision",
      fechaFinRemision: "Fecha Fin Remision",
    },
    errores: {
      tipoDocumentoRequerido: "Elige el documento",
      numeroMaximaLongitud: "Máximo 15 dígitos",
      numeroFormatoInvalido: "Número inválido",
    },
    mensajes: {
      informacion:
        "En caso de no seleccionar ningún estado, el informe estara conformado por remisiónes en estado nuevo, pendiente admitir y cancelado",
    },
    botones: {
      buscar: "Buscar",
      limpiar: "Limpiar",
      descargarInforme: "Descargar informe",
    },
    tabla: {
      idRemision: "idRemision",
      numeroRemisionCampo: "idRemision",
      numeroRemision: "Numero remisión",
      fechaRemisionCampo: "fechaRemision",
      fechaRemision: "Fecha remisión",
      nombrePacienteCampo: "nombrePaciente",
      nombrePaciente: "Paciente",
      planSaludCampo: "planSalud",
      planSalud: "Plan",
      estadoRemisionCampo: "estadoRemision",
      estadoRemision: "Estado",
      usuarioModificaCampo: "usuario",
      usuarioModifica: "Usuario",
      accion: "Acción",
      eliminar: "Eliminar",
      editar: "Editar",
      noRemisiones: "No se han agregado remisiones",
      totalRegistros: "Total registros: ",
      institucionRemitente: "Institución Remitente ",
      institucionRemitenteCampo: "institucionRemitente",
      tipoAtencion: "Tipo Atención",
      tipoAtencionCampo: "tipoAtencion"
    },
  },

  planManejo: {
    campos: {
      tratamientos: "Tratamientos",
      procedimientos: "Procedimientos",
      valoraciones: "Valoraciones",
      valoracionBebeCanguro: "Bebé canguro",
      pacientePICC: "Paciente con PICC CVC",
      curaciones: "Curaciones",
      sondajes: "Sondajes",
      fototerapias: "Fototerapias",
      tomaMuestras: "Toma de muestras",
      secreciones: "Secreciones",
      soporteNutricional: "Soporte nutricional",
    },
    botones: {
      agregarValoraciones: "Agregar valoraciones",
    },
    tabla: {
      id: "id",
      medicamentoCampo: "medicamentoDescripcion",
      medicamento: "Medicamento",
      dosisCampo: "cantidadDosis",
      dosis: "Cantidad",
      estado: "Estado",
      viaAdministracionCampo: "viaAdministracion",
      viaAdministracion: "Via administración",
      tipoNutricionCampo: "tipoNutricionDescripcion",
      tipoNutricion: "Tipo nutrición",
      nutricionCampo: "nutricionDescripcion",
      nutricion: "Nutrición",
      frecuenciaCampo: "frecuenciaDescripcion",
      frecuencia: "Frecuencia",
      duracionCampo: "duracion",
      duracion: "Duración",
      ultimaAplicacionCampo: "ultimaAplicacion",
      ultimaAplicacion: "Última aplicacion",
      noPBSCampo: "noPBS",
      noPBS: "No PBS",
      esUltimaAplicacionCampo: "esUltimaAplicacion",
      esUltimaAplicacion: "¿Última Aplicacion?",
      dosisFaltantesCampo: "dosisFaltantes",
      dosisFaltantes: "Dosis faltantes",
      accion: "Acciones",
      eliminar: "Eliminar",
      editar: "Editar",
      noTratamientos: "El paciente no tiene tratamientos",
      noProfesional: "El profesionales Asiganados",
      noCuraciones: "El paciente no tiene curaciones",
      noSondajes: "El paciente no tiene sondajes",
      noFototerapias: "El paciente no tiene fototerapias",
      tituloEliminarTratamiento: "Eliminar tratamiento",
      contenidoEliminarTratamiento: "¿Está seguro de eliminar el tratamiento?",
      tituloEliminarProcedimiento: "Eliminar procedimiento",
      contenidoEliminarProcedimiento:
        "¿Está seguro de eliminar el procedimiento?",
      totalRegistros: "Total registros: ",
    },
    mensajesValidacion: {
      agregarValoraciones:
        "Se han agregado las valoraciones correctamente, recuerde guardar los cambios en el FUR",
    },

    tratamientos: {
      campos: {
        medicamento: "Medicamento",
        medicamentoCodigo: "Código",
        medicamentoNombre: "Nombre",
        medicamentoBuscar: "Buscar por código o nombre",
        dosis: "Cantidad",
        dosisUnidades: "Unidades",
        viaAdministracion: "Via administración",
        observacion: "Observación",
        hospital: "Hospital",
        viaAdministracionSeleccionar: "Seleccionar",
        frecuencia: "Frecuencia",
        frecuenciaSeleccionar: "Seleccionar",
        duracion: "Duración",
        duracionCantidad: "Cantidad",
        duracionDosis: "Dosis",
        duracionDosisOxigeno: "Días",
        tieneUltimaAplicacion: "¿Tiene última aplicación?",
        ultimaAplicacion: "Última aplicación",
        noPBS: "No PBS",
        diluyente: "Diluyente",
        diluyenteTitulo: "Diluyente *:",
        diluyenteSolucionSalina: "Solución salina 0.9%",
        diluyenteOtro: "Agua destilada",
        diluyenteCantidad: "Cantidad",
        ml: "m.l",
        requiereEquipo: "¿Requiere equipo?",
        fechaFinTratamiento: "Fecha fin tratamiento: ",
        tipoNutricion: "Tipo de nutrición",
        requiereCilindroPortatil: "Requiere cilindro portátil",
        MipresRequerido: "Medicamento requiere registro Mipres",
      },
      errores: {
        codigoMedicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
        codigoMedicamentoInvalido: "Código inválido",
        medicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
        medicamentoInvalido: "Medicamento inválido",
        medicamentoRequerido: "Ingresa el código o nombre del medicamento",
        dosisCantidadRequerido: "Ingresa la cantidad",
        dosisCantidadMaximaLongitud: "Cantidad inválida",
        dosisCantidadInvalido: "Cantidad inválida",
        dosisUnidadesRequerido: "Seleccione unidad de dosis",
        viaAdministracionRequerido: "Seleccione vía administración",
        frecuenciaRequerido: "Seleccione frecuencia",
        duracionRequerido: "Ingresa la duración",
        duracionInvalido: "Duración inválida",
        duracionMin: "Duración minima de 1 dosis",
        duracionMax: "Duración máxima de 999 dosis",
        diluyenteRequerido: "Ingrese diluyente",
        diluyenteOpcionRequerido: "Seleccione una opción",
        diluyenteCantidadRequerido: "Ingresa la cantidad",
        diluyenteCantidadMaximaLongitud: "Cantidad inválida",
        diluyenteCantidadInvalido: "Cantidad inválida",
        codigoOxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
        codigoOxigenoInvalido: "Código inválido",
        oxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
        oxigenoInvalido: "Oxigeno inválido",
        oxigenoRequerido: "Ingresa el código o nombre del medicamento",
        fechaUltimaAplicacionRequerido: "Ingrese fecha de última aplicación",
        tipoNutricionRequerido: "Seleccione tipo nutrición",
        nutricionOpcionRequerido: "Seleccione una opción",
        observacionRequerida: "Ingrese una observación, ejm(# Habitación)",
        observacionMaximaLongitud: "Cantidad invalida",
        ObservacionInvalida: "Número inválido",
        MipresRequerido: "Medicamento requiere registro Mipres",
      },
      opcionesMenu: {
        medicamentos: "Medicamentos",
        nebulizaciones: "Nebulizaciones",
        oxigenoterapia: "Oxigenoterapia",
        soporteNutricional: "Soporte nutricional",
      },
      tituloVentana: {
        agregarEditarMedicamentos: "Agregar / Editar Medicamentos",
        agregarEditarNebulizaciones: "Agregar / Editar Nebulizaciones",
        agregarEditarOxigeno: "Agregar / Editar Oxigeno",
        agregarEditarSoporteNutricional: "Agregar / Editar Soporte Nutricional",
      },
      botones: {
        cancelar: "Cancelar",
        guardar: "Guardar",
        agregar: "Agregar",
        editar: "Editar",
      },
      urls: {
        urlNoPBS:
          "https://mipres.sispro.gov.co/MIPRESNOPBS/Login.aspx?ReturnUrl=%2fMIPRESNOPBS%2fExito.aspx",
      },
    },

    procedimientos: {
      curaciones: {
        campos: {
          descripcion: "Descripción",
          proximaCuracion: "Proxima curación",
        },
        errores: {
          descripcionRequerido: "Ingresa la descripcion",
          descripcionMaximaLongitud: "Cantidad inválida",
          proximaCuracionRequerido: "Ingrese la fecha",
        },
        tabla: {
          tipoCuracionCampo: "Herida mayor",
          tipoCuracion: "Tipo de curación",
          descripcionCampo: "descripcion",
          descripcion: "Descripción",
          proximaCuracionCampo: "proximaCuracion",
          proximaCuracion: "Proxima curación",
          accion: "Acción",
          editar: "Editar",
          eliminar: "Eliminar",
          noCuraciones: "No se han agregado curaciones",
          totalRegistros: "Total registros: ",
        },
      },
      sondajes: {
        campos: {
          tipoSondajeIngreso: "Tipo de sondaje",
          tipoSondajeNovedades: "Tipo de sondaje",
          tipoDeSondaje: "Tipo de sondaje",
          fechaInicioPrestacion: "Fecha Inicio Prestación",
          alimentacion: "Alimentación",
          evacuacion: "Evacuación",
          drenaje: "Drenaje",
          requiereAyuno: "Requiere ayuno",
          tomaMuestra: "Toma de Muestra",
        },
        errores: {
          sondajeRequerido: "Seleccione sondaje",
          sondajesRequeridos: "Seleccione al menos un sondaje",
          sondajeInvalido: "El sondaje seleccionado ya se encuentra listado",
          drenajeRequerido: "Seleccione drenaje",
        },
        tabla: {
          tipoSondajeCampo: "sondaje",
          tipoSondajeIngreso: "Tipo sondaje",
          tipoSondajeNovedades: "Tipo sondaje",
          categoriaSondajeCampo: "idTipoSondaje",
          categoriaSondaje: "Categoría",
          accion: "Acción",
          editar: "Editar",
          eliminar: "Eliminar",
          noSondajes: "No se han agregado sondajes",
          totalRegistros: "Total registros: ",
        },
        tipos: {
          drenaje: "DRENAJE",
          alimentacion: "ALIMENTACION",
          tomaMuestra: "TOMAMUESTRA",
          evacuacion: "EVACUACION",
        },
      },

      fototerapias: {
        campos: {
          diasTratamiento: "Días de tratamiento",
          bilirrubinaTotal: "Bilirrubina total",
          ultimaTomaMuestra: "Última toma de muestra",
          tipoFrecuencia: "Tipos frecuencia",
          dosisFaltantes: "Dosis faltantes"
        },
        errores: {
          diasTratamientoRequerido: "Ingrese días de tratamiento",
          diasTratamientoMinimoValor: "Minimo 1 día de tratamiento",
          diasTratamientoMaximoValor: "Máximo 7 días de tratamiento",
          diasTratamientoInvalido: "Días de tratamiento inválido",
          bilirrubinaTotalRequerido: "Ingrese bilirrubina total",
          bilirrubinaTotalMinimoValor: "Minimo 12.00 de bilirrubina total",
          bilirrubinaTotalMaximoValor: "Máximo 20.99 de bilirrubina total",
          bilirrubinaTotalInvalido: "Bilirrubina total inválido",
          ultimaTomaMuestraRequerido: "Ingrese la fecha",
          tipoFrecuenciaRequerido: "Seleccione el tipo de frecuencia",
        },
        tabla: {
          diasTratamientoCampo: "diasTratamiento",
          diasTratamiento: "Días de tratamiento",
          bilirrubinaTotalCampo: "bilirrubinaTotal",
          bilirrubinaTotal: "Bilirrubina total",
          ultimaTomaMuestraCampo: "ultimaTomaMuestra",
          ultimaTomaMuestra: "Última toma de muestra",
          tipoFrecuenciaCampo: "tipoFrecuencia",
          tipoFrecuencia: "Tipo frecuencia",
          accion: "Acción",
          editar: "Editar",
          eliminar: "Eliminar",
          noFototerapias: "No se han agregado fototerapias",
          totalRegistros: "Total registros: ",
          dosisFaltantes: "Dosis faltantes",
        },
        textoFototerapia: "FOTOTERAPIA",
      },

      tomaMuestra: {
        campos: {
          tipoMuestra: "Tipo toma de muestra",
        },
        errores: {
          tipoMuestraRequerido: "Seleccione el tipo de muestra",
        },
        tabla: {
          tipoMuestraCampo: "tipoMuestraDescripcion",
          tipoMuestra: "Tipo toma de muestra",
          descripcionCampo: "descripcion",
          descripcion: "Descripción",
          accion: "Acción",
          editar: "Editar",
          eliminar: "Eliminar",
          noTomaMuestras: "No se han agregado toma de muestras",
          totalRegistros: "Total registros: ",
        },
      },

      secreciones: {
        campos: {
          diasTratamiento: "Días de tratamiento",
          envioAspirador: "Envío de aspirador",
          visitaEnfermeria: "Visita de enfermería",
          tipoSonda: "¿Tipo de sonda? *",
          pediatrica: "Pediatrica",
          adulto: "Adulto",
          via: "Via",
          nasal: "Nasal",
          traqueostomia: "Traqueostomía",
        },
        errores: {
          diasTratamientoRequerido: "Ingrese días de tratamiento",
          diasTratamientoMinimoValor: "Minimo 1 día de tratamiento",
          diasTratamientoMaximoValor: "Máximo 30 días de tratamiento",
          diasTratamientoInvalido: "Días de tratamiento inválido",
          tipoSondaRequerido: "Seleccione el tipo de sonda",
        },
        tabla: {
          diasTratamientoCampo: "diasTratamiento",
          diasTratamiento: "Días de tratamiento",
          envioAspiradorCampo: "envioAspirador",
          envioAspirador: "Envío de aspirador",
          visitaEnfermeriaCampo: "visitaEnfermeria",
          visitaEnfermeria: "Visita de enfermería",
          tipoSondaCampo: "tipoSonda",
          tipoSonda: "Tipo de sonda",
          nasalCampo: "nasal",
          nasal: "Nasal",
          traqueostomiaCampo: "traqueostomia",
          traqueostomia: "Traqueostomía",
          accion: "Acción",
          editar: "Editar",
          eliminar: "Eliminar",
          noSecreciones: "No se han agregado aspiraciones de secreciones",
          totalRegistros: "Total registros: ",
        },
      },

      canalizaciones: {
        campos: {
          tipoCanalizacion: "Tipo de canalización",
          sesionesFaltantes: "Sesiones Faltantes",
          visitaEnfermeria: "Fecha proxima sesión",
        },
        errores: {
          tipoCanalizacionRequerido: "Seleccione el tipo de canalización",
          fechaRequerido: "Ingrese la fecha",
        },
        tabla: {
          tipoCanalizacion: "Tipo de canalización",
          sesionesFaltantes: "Sesiones Faltantes",
          visitaEnfermeria: "Fecha proxima sesión",
          accion: "Acción",
          editar: "Editar",
          eliminar: "Eliminar",
          totalRegistros: "Total registros: ",
          noCanalizaciones: "No se han agregado canalizaciones",
        },
      },

      soporteNutricional: {
        campos: {
          medicamento: "Medicamento",
          medicamentoCodigo: "Código",
          medicamentoNombre: "Nombre",
          medicamentoBuscar: "Buscar por código o nombre",
          dosis: "Cantidad",
          dosisUnidades: "Unidades",
          tipoNutricion: "Tipo nutrición",
          nutricion: "Nutrición",
          frecuencia: "Frecuencia",
          frecuenciaSeleccionar: "Seleccionar",
          duracion: "Tiempo infusión",
          duracionCantidad: "Cantidad",
          duracionDosis: "Dosis",
          noPBS: "No PBS",
          diasTratamiento: "Días tratamiento",
          volumen: "Volumen (gr)",
          diasEvento: "Dias",
          horaEvento: "Hora",
        },
        errores: {
          codigoMedicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
          codigoMedicamentoInvalido: "Código inválido",
          medicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
          medicamentoInvalido: "Medicamento inválido",
          medicamentoRequerido: "Ingresa el código o nombre del medicamento",
          dosisCantidadRequerido: "Ingresa la cantidad",
          dosisCantidadMaximaLongitud: "Cantidad inválida",
          dosisCantidadInvalido: "Cantidad inválida",
          dosisUnidadesRequerido: "Seleccione unidades",
          viaAdministracionRequerido: "Seleccione vía administración",
          frecuenciaRequerido: "Seleccione frecuencia",
          duracionRequerido: "Ingrese el tiempo",
          duracionInvalido: "Tiempo inválido",
          duracionMin: "Tiempo minimo de 1",
          duracionMax: "Tiempo máximo de 999",
          diasTratamientoRequerido: "Ingresa la cantidad",
          diasTratamientoInvalido: "Cantidad inválida",
          diasTratamientoMin: "Minimo 1 día",
          diasTratamientoMax: "Máximo 99 días",
          volumenRequerido: "Ingresa la cantidad",
          volumenInvalido: "Volumen inválido",
          volumenMin: "Minimo 1 gr",
          volumenMax: "Máximo 9000 gr",
          diluyenteRequerido: "Ingrese diluyente",
          diluyenteOpcionRequerido: "Seleccione una opción",
          diluyenteCantidadRequerido: "Ingresa la cantidad",
          diluyenteCantidadMaximaLongitud: "Cantidad inválida",
          diluyenteCantidadInvalido: "Cantidad inválida",
          codigoOxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
          codigoOxigenoInvalido: "Código inválido",
          oxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
          oxigenoInvalido: "Oxigeno inválido",
          oxigenoRequerido: "Ingresa el código o nombre del medicamento",
          fechaUltimaAplicacionRequerido: "Ingrese fecha de última aplicación",
          tipoNutricionRequerido: "Seleccione tipo nutrición",
          nutricionRequerido: "Seleccione nutrición",
          diasEventoRequerido: "Seleccione el día",
          horaEventoRequerido: "Seleccione la hora",
          tipoEventoRequerido: "Seleccione el tipo",
          eventoRequerido: "Agrega al menos un evento",
          fechaRequerido: "Ingrese fecha",
        },
        tabla: {
          id: "id",
          medicamentoCampo: "medicamentoDescripcion",
          medicamento: "Medicamento",
          dosisCampo: "cantidadDosis",
          dosis: "Cantidad",
          tipoNutricionCampo: "tipoNutricionDescripcion",
          tipoNutricion: "Tipo nutrición",
          nutricionCampo: "nutricionDescripcion",
          nutricion: "Nutrición",
          frecuenciaCampo: "frecuenciaDescripcion",
          frecuencia: "Frecuencia",
          duracionCampo: "duracion",
          duracion: "Duración",
          noPBSCampo: "noPBS",
          noPBS: "No PBS",
          diasCampo: "diasEvento",
          dias: "Días",
          horaCampo: "frecuenciaDescripcion",
          hora: "Hora",
          eventoCampo: "eventoDescripcion",
          evento: "Evento",
          diasTratamientoCampo: "diasTratamiento",
          diasTratamiento: "Días tratamiento",
          accion: "Acciones",
          eliminar: "Eliminar",
          editar: "Editar",
          noSoporteNutricional: "El paciente no tiene soporte nutricional",
          noEventos: "No se han agregado eventos",
          totalRegistros: "Total registros: ",
        },
        tiposNutricion: {
          enteral: "Enteral",
          parenteral: "Parenteral",
        },
      },

      opcionesMenu: {
        curaciones: "Curaciones",
        sondajes: "Sondajes",
        fototerapias: "Fototerapias",
        tomaDeMuestra: "Toma muestra",
        secreciones: "Secreciones",
        soporteNutricional: "Soporte nutricional",
      },
      tituloVentana: {
        agregarEditarCuraciones: "Agregar / Editar Curaciones",
        agregarEditarSondajes: "Agregar / Editar Sondajes",
        agregarEditarFototerapias: "Agregar / Editar Fototerapias",
        agregarEditarTomaMuestras: "Agregar / Editar Toma muestra",
        agregarEditarAspiracionSecreciones:
          "Agregar / Editar Aspiración de secreciones",
        agregarEditarSoporteNutricional: "Agregar / Editar Soporte nutricional",
      },
      botones: {
        cancelar: "Cancelar",
        guardar: "Guardar",
        agregar: "Agregar",
        editar: "Editar",
      },
      urls: {
        urlNoPBS:
          "https://mipres.sispro.gov.co/MIPRESNOPBS/Login.aspx?ReturnUrl=%2fMIPRESNOPBS%2fExito.aspx",
      },
    },

    valoraciones: {
      tipos: {
        poliza: "poliza",
        ingresoPolizaVida: "Ingreso Póliza de Vida",
      },
      identificadores: {
        ingresoPolizaVida: "4",
        fonoaudiologiaCanguro: "24",
        enfermeriaCanguro: "9",
        examenMedico: "11",
      },
      campos: {
        fechaExamenMedico: "Fecha examen",
      },
      validaciones: {
        valoracionesTipoPoliza:
          "Seleccione al menos una valoración del tipo Ingreso póliza de vida",
        fechaExamenMedicoRequerido: "Seleccione fecha",
      },
      botones: {
        cancelar: "Cancelar",
        guardar: "Guardar",
      },
    },
  },

  valoracionesPlanManejo: {
    tipos: {
      poliza: "poliza",
      ingresoPolizaVida: "Ingreso Póliza de Vida",
    },
    botones: {
      agregarValoraciones: "Agregar valoraciones",
    },
  },

  novedades: {
    inicioNovedad: {
      campos: {
        tipoDocumentoPaciente: "Tipo identificación",
        numeroDocumentoPaciente: "Número identificación",
        remisionPaciente: "Remisión",
        textoRemision: "Remisión: ",
        textoPaciente: "Paciente: ",
        remisionCampo: "remision",
        pisoCampo: "piso",
        nombreCampo: "nombre",
        programaCampo: "programa"
      },
      errores: {
        tipoDocumentoPacienteRequerido: "Seleccione el tipo",
        numeroDocumentoPacienteRequerido: "Ingresa el número",
        numeroDocumentoPacienteMaximaLongitud: "Máxima longitud 20 dígitos",
        numeroDocumentoPacienteInvalido: "Número inválido",
        remisionPacienteRequerido: "Ingresa el número de remisón",
        remisionPacienteMaximaLongitud: "Máxima longitud 15 dígitos",
        remisionPacienteInvalido: "Número inválido",
      },
      botones: {
        buscarPaciente: "Buscar paciente",
        volverAtras: "Volver",
      },
      opcionesMenu: {
        principal: "Principal",
        cancelaVisita: "Cancela Visita",
        egreso: "Egreso",
        infoPaciente: "Info. Paciente",
        tratamientoProcedimiento: "Plan de Manejo",
        cita: "Citas",
        aplicacionesCuidador: "Aplicaciones por cuidador",
        alertasVisitas: "Alertas en visita",
        equiposBiomedicos: "Equipos Biomédicos",
        modificarVisitas: "Modificar visitas",
        tomaMuestra: "Toma de muestra",
      },
      titulos: {
        paciente: "Paciente: ",
        cancelaVisita: "Cancela Visita",
        egreso: "Novedad Egreso",
        infoPaciente: "Información Paciente",
        tratamientoProcedimiento: "Plan de Manejo",
        cita: "Citas",
        aplicacionesCuidador: "Aplicaciones por cuidador",
        alertasVisitas: "Alertas en visita",
        equiposBiomedicos: "Equipos Biomédicos",
        nombre: "Paciente ",
        tipoAfiliacion: "Afiliación ",
        edad: "Edad ",
        sexo: "Sexo ",
        piso: "Piso",
        tipoAdmision: "Tipo admisión",
        modificarVisitas: "Modificar visitas",
        programa: "Programa",
        accion: "Acción",
        remision: "Remisión",
        tomaMuestra: "Toma de muestra",
      },
      validaciones: {
        noRemisionActiva:
          "No existe una remisión activa para la información ingresada",
      },
    },

    cancelarCita: {
      campos: {
        motivoCancelaCita: "Motivo de cancelación",
        observacion: "Observación",
      },
      errores: {
        motivoCancelaCitaRequerido: "Seleccione el motivo",
        seleccionCitaRequerido: "Seleccione al menos una cita a cancelar",
      },
      botones: {
        cancelarCitas: "Cancelar citas",
      },
      tabla: {
        fechaVisitaCampo: "fechaInicioCita",
        fechaVisita: "Fecha visita",
        tipoCitaCampo: "tipoCita",
        tipoCita: "Tipo",
        especialidadCampo: "especialidad",
        especialidad: "Especialidad",
        visualizar: "Visualizar",
        noCitas: "El paciente no tiene visitas programadas",
        totalRegistros: "Total registros: ",
      },
      mensajesAlerta: {
        exitoCancelarCita: "Se ha cancelado la visita exitosamente",
        errorCancelarCita: "Ha ocurrido un error, favor intente más tarde",
      },
    },

    detalleVisitaCuidador: {
      campos: {
        motivoNovedad: 'Motivos novedad'
      },
      tabla: {
        horaVisita: 'Horas visitas'
      },
      errores: {
        motivoNovedadRequerido: 'Seleccione el motivo',
        seleccionCitaRequerido: 'Seleccione al menos una cita'
      },
      botones: {
        aplicar: 'Aplicar'
      }
    },

    aplicacionCuidador: {
      campos: {
        motivoNovedad: 'Motivo novedad'
      },

      tabla: {
        id: 'id',
        medicamentoCampo: 'medicamentoDescripcion',
        medicamento: 'Medicamento',
        dosisCampo: 'cantidadDosis',
        dosis: 'Cantidad',
        estado: 'Estado',
        viaAdministracionCampo: 'viaAdministracion',
        viaAdministracion: 'Via administración',
        frecuenciaCampo: 'frecuenciaDescripcion',
        frecuencia: 'Frecuencia',
        duracionCampo: 'duracion',
        duracion: 'Duración',
        dosisFaltantesCampo: 'dosisFaltantes',
        dosisFaltantes: 'Dosis faltantes',
        aplicaCuidador: 'Aplica cuidador',
        accion: 'Acciones',
        noTratamientos: 'El paciente no tiene tratamientos',
        editar: 'Editar',
        totalRegistros: 'Total registros: '
      },
      tratamientos: {
        campos: {
          medicamento: 'Medicamento',
          medicamentoCodigo: 'Código',
          medicamentoNombre: 'Nombre',
          dosis: 'Cantidad',
          dosisUnidades: 'Unidades',
          viaAdministracion: 'Via administración',
          viaAdministracionSeleccionar: 'Seleccionar',
          aplicaCuidador: 'Aplica cuidador',
          tipoNutricion: 'Tipo de nutrición',
          frecuencia: 'Frecuencia',
          frecuenciaSeleccionar: 'Seleccionar',
          duracion: 'Duración',
          duracionCantidad: 'Cantidad',
          duracionDosis: 'Dosis'
        }
      },
      mensajesAlerta: {
        exitoAplicarAplicacion: 'Se han aplicado las visitas exitosamente',
        errorAplicarAplicacion: 'Ha ocurrido un error, favor intente más tarde'
      }
    },

    egreso: {
      campos: {
        motivoEgreso: "Motivo egreso",
        fechaAlta: "Fecha alta *",
        fechaAltaDetalle: "Fecha alta ",
        fechaEgreso: "Fecha egreso",
        observacion: "Observación",
      },
      errores: {
        motivoEgresoRequerido: "Seleccione el motivo",
        fechaAltaRequerido: "Ingresa la fecha",
        observacionRequerido: "Ingresa la observación",
      },
      botones: {
        egresar: "Egresar",
      },
      mensajesAlerta: {
        exitoEgreso: "Novedad enviada a gestión exitosamente",
        errorEgreso: "Ha ocurrido un error, favor intente más tarde",
      },
      titulos: {
        egreso: "Egreso",
      },
    },

    informacionPaciente: {
      opcionesMenu: {
        principal: "Principal",
        datosPaciente: "Datos del Paciente",
        direccion: "Dirección",
        glucomer: "Glucomer",
        diagnostico: "Diagnóstico",
        estadoClinico: "Estado Clinico",
        cambioPiso: "Cambio Piso",
        asignarProfesional: "Asignar Profesional",
        clasificacionPermanente: "Clasificación Permanente",
      },
      datosPaciente: {
        campos: {
          ciudadPrincipal: "Ciudad principal",
          municipio: "Municipio",
          barrio: "Barrio",
          direccion: "Dirección atención",
          nombreCuidador: "Nombre cuidador",
          nombreResponsable: "Nombre responsable",
          telefonoPaciente: "Teléfono paciente",
          telefonoPacienteRequerido: "Teléfono paciente *",
          celularPaciente: "Celular 1 paciente",
          celularPaciente2: "Celular 2 paciente",
          celularPacienteRequerido: "Celular paciente *",
          emailPaciente: "Email de paciente",
          emailPacienteRquerido: "Email de paciente *",
        },
        errores: {
          ciudadPrincipalRequerida: "Elige la ciudad",
          municipioRequerido: "Elige el municipio",
          barrioRequerido: "Elige el barrio",
          direccionRequerida: "Ingresa la dirección",
          nombreCuidadorRequerido: "Ingresa el cuidador",
          nombreCuidadorMaximaLongitud: "Máximo 50 caracteres",
          nombreResponsableRequerido: "Ingresa el responsable",
          nombreResponsableMaximaLongitud: "Máximo 50 caracteres",
          telefonoRequerido: "Ingresa el teléfono",
          telefonoMaximaLongitud: "Máximo 7 dígitos",
          telefonoInvalido: "Teléfono inválido",
          celularRequerido: "Ingresa el celular",
          celularMaximaLongitud: "Máximo 10 dígitos",
          celularInvalido: "Celular inválido",
          emailPacienteRequerido: "Ingresa el email",
          emailPacienteMaximaLongitud: "Máxima longitud 50 caracteres",
          emailPacienteInvalido: "Email inválido",
        },
        botones: {
          guardar: "Guardar",
        },
        titulos: {
          datosPaciente: "Datos Paciente",
        },
        mensajesAlerta: {
          exitoCambioDatosPaciente: "Novedad enviada a gestión exitosamente",
          errorCambioDatosPaciente:
            "Ha ocurrido un error, favor intente más tarde",
          errorCargarDatosPaciente:
            "Ha ocurrido un error al cargar los datos del paciente, favor intente más tarde",
        },
      },

      diagnosticos: {
        campos: {
          diagnostico: "Diagnóstico por el que se remite",
          buscar: "Buscar por código o nombre",
          eliminar: "Eliminar",
        },
        errores: {},
        tabla: {
          codigoCampo: "codigo",
          codigo: "Código",
          nombreCampo: "nombre",
          nombre: "Nombre",
          accion: "Acción",
          eliminar: "Eliminar",
          noDiagnosticos: "No se han agregado diagnósticos",
          totalRegistros: "Total registros: ",
        },
        botones: {
          guardar: "Guardar",
        },
        titulos: {
          diagnosticos: "Diagnosticos",
        },
        mensajesAlerta: {
          exitoCambioDiagnostico: "Se ha cambiado el diagnóstico exitosamente",
          errorCambioDiagnostico:
            "Ha ocurrido un error, favor intente más tarde",
          errorCargarDiagnostico:
            "Ha ocurrido un error al cargar los diagnósticos, favor intente más tarde",
          noCambioDiagnostico:
            "No se ha presentado modificación de diagnóstico",
        },
      },

      cambioPiso: {
        campos: {
          piso: "Piso",
          observacion: "Observación *",
        },
        errores: {
          pisoRequerido: "Seleccione el piso",
          observacionRequerido: "Ingresa la observación",
          observacionMaximaLongitud: "Máxima longitud 4000 dígitos",
        },
        botones: {
          asignarPiso: "Asignar Piso",
        },
        titulos: {
          cambioPiso: "Cambio de piso",
        },
        mensajesAlerta: {
          exitoCambioPiso: "Novedad enviada a gestión exitosamente",
          errorCambioPiso: "Ha ocurrido un error, favor intente más tarde",
          noCambioPiso: "No se ha presentado modificación de piso",
          errorCargarInfoPiso:
            "Ha ocurrido un error al cargar la información actual del piso y/o el egreso, favor intente más tarde",
        },
      },
      asignarProfesional: {
        campos: {
          profesional: "Profesionales",
        },
        errores: {
          pisoRequerido: "Seleccione el piso",
          observacionRequerido: "Ingresa la observación",
          observacionMaximaLongitud: "Máxima longitud 4000 dígitos",
        },
        botones: {
          asignarProfesional: "Asignar Profesional",
          anularAsignacion: "Anular Asignación",
        },
        titulos: {
          asignarProfesional: "Asignar Profesional",
        },
        mensajesAlerta: {
          exitoCambioPiso: "Novedad enviada a gestión exitosamente",
          errorCambioPiso: "Ha ocurrido un error, favor intente más tarde",
          noCambioPiso: "No se ha presentado modificación de piso",
          errorCargarInfoPiso:
            "Ha ocurrido un error al cargar la información actual del piso y/o el egreso, favor intente más tarde",
        },
      },
      clasificacionPermanentes: {
        campos: {
          clasificacion: "Clasificación Permanente",
        },
        errores: {
          clasificacionRequerida: "Seleccione clasificación",
        },
        botones: {
          asignarClasificacion: "Guardar",
        },
        titulos: {
          clasificacionPermanente: "Clasificación Permanente",
        },
        mensajesAlerta: {
          exitoCambioPiso: "Novedad enviada a gestión exitosamente",
          errorCambioPiso: "Ha ocurrido un error, favor intente más tarde",
          noCambioPiso: "No se ha presentado modificación de piso",
          errorCargarInfoPiso:
            "Ha ocurrido un error al cargar la información actual, favor intente más tarde",
        },
      },
    },

    planManejoNovedades: {
      tablaProfesionales: {
        nombreCampo: "Nombre",
        nombre: "Nombre",
        especialidadCampo: "Especialidad",
        especialidad: "Especialidad",
        regionCampo: "Region",
        region: "Region",
      },
      campos: {
        tratamientos: "Tratamientos",
        imagenesDiagnosticas: "Imágenes diagnosticas",
        profesional: "Profesionales",
        procedimientos: "Procedimientos",
        ImagenesDiagnosticas: "Imágenes diagnosticas",
        valoraciones: "Valoraciones",
        pacientePICC: "Paciente con PICC CVC",
        curaciones: "Curaciones",
        terapias: "Terapias",
        fototerapias: "Fototerapias",
        tomaMuestras: "Toma de muestras",
        secreciones: "Secreciones",
        canalizaciones: "Canalizaciones",
        soporteNutricional: "Soporte nutricional",
        citasEnfermeria: "Citas enfermería",
      },
      botones: {
        agregarValoraciones: "Agregar valoraciones",
        guardarPlanManejo: "Guardar",
      },
      tabla: {
        id: "id",
        medicamentoCampo: "medicamentoDescripcion",
        medicamento: "Medicamento",
        dosisCampo: "cantidadDosis",
        dosis: "Dosis",
        viaAdministracionCampo: "viaAdministracion",
        viaAdministracion: "Via administración",
        tipoNutricionCampo: "tipoNutricionDescripcion",
        tipoNutricion: "Tipo nutrición",
        nutricionCampo: "nutricionDescripcion",
        nutricion: "Nutrición",
        frecuenciaCampo: "frecuenciaDescripcion",
        frecuencia: "Frecuencia",
        duracionCampo: "duracion",
        duracion: "Total dosis a aplicar",
        ultimaAplicacionCampo: "ultimaAplicacion",
        ultimaAplicacion: "Última aplicacion",
        noPBSCampo: "noPBS",
        noPBS: "No PBS",
        esUltimaAplicacionCampo: "esUltimaAplicacion",
        esUltimaAplicacion: "¿Última Aplicacion?",
        dosisFaltantesCampo: "dosisFaltantes",
        dosisFaltantes: "Dosis faltantes",
        fechaProximaDosisCampo: "fechaProximaDosis",
        fechaProximaDosis: "Fecha de proxima dosis",
        accion: "Acciones",
        eliminar: "Eliminar",
        editar: "Editar",
        noTratamientos: "El paciente no tiene tratamientos",
        noImagenesDiagnosticas: "El paciente no tiene imagenes diagnosticas",
        noProfesional: "El paciente no tiene profesionales Asignados",
        noCuraciones: "El paciente no tiene curaciones",
        noSondajes: "El paciente no tiene sondajes",
        tituloEliminarTratamiento: "Eliminar tratamiento",
        contenidoEliminarTratamiento:
          "¿Está seguro de eliminar el tratamiento?",
        tituloEliminarProcedimiento: "Eliminar procedimiento",
        contenidoEliminarProcedimiento:
          "¿Está seguro de eliminar el procedimiento?",
        tituloEliminarValoracion: "Eliminar valoración",
        contenidoEliminarValoracion: "¿Está seguro de eliminar la valoración?",
        tituloEliminarImagenDiagnostica: "Eliminar imagen diagnostica",
        contenidoEliminarImagenDiagnostica:
          "¿Está seguro de eliminar la imagen diagnostica?",
        totalRegistros: "Total registros: ",
        dosisRescate: "Dosis rescate",
        aplicaCuidador: "Aplica cuidador",
      },
      mensajesValidacion: {
        agregarValoraciones:
          "Se han agregado las valoraciones correctamente, recuerde guardar los cambios en el FUR",
      },
      mensajesAlerta: {
        exitoCambioPlan: "Novedad enviada a gestión exitosamente",
        errorCambioPlan: "Ha ocurrido un error, favor intente más tarde",
        errorCargarPlan:
          "Ha ocurrido un error al cargar el plan de manejo, favor intente más tarde",
        noCambioPlan:
          "No se han presentado cambios en tratamientos y/o procedimientos",
        sondajeSinTomaMuestra:
          "La Sonda Nasogástrica Bk debe ir acompañada de una Toma de Muestra Baciloscopia",
        tomaMuestraSinSondaje:
          "La Toma de Muestra Baciloscopia debe ir acompañada de una Sonda Nasogástrica Bk",
      },

      tratamientos: {
        campos: {
          medicamento: "Medicamento",
          medicamentoCodigo: "Código",
          medicamentoNombre: "Nombre",
          medicamentoBuscar: "Buscar por código o nombre",
          dosis: "Dosis",
          dosisUnidades: "Unidades",
          viaAdministracion: "Via administración",
          viaAdministracionSeleccionar: "Seleccionar",
          tipoNutricion: "Tipo de nutrición",
          frecuencia: "Frecuencia",
          frecuenciaSeleccionar: "Seleccionar",
          duracion: "Duración",
          duracionCantidad: "Cantidad",
          duracionDosis: "Dosis",
          duracionDosisOxigeno: "Días",
          tieneUltimaAplicacion: "¿Tiene última aplicación?",
          ultimaAplicacion: "Última aplicación",
          noPBS: "No PBS",
          diluyente: "Diluyente",
          diluyenteTitulo: "Diluyente *:",
          diluyenteSolucionSalina: "Solución salina 0.9%",
          diluyenteOtro: "Agua destilada",
          diluyenteCantidad: "Cantidad",
          ml: "m.l",
          requiereEquipo: "¿Requiere equipo?",
          fechaFinTratamiento: "Fecha fin tratamiento: ",
          MipresRequerido: "Medicamento requiere registro Mipres",
          modificarDosis: "Modificar dosis",
          adicionarDosis: "Adicionar dosis",
          disminuirDosis: "Disminuir dosis",
        },
        errores: {
          codigoMedicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
          codigoMedicamentoInvalido: "Código inválido",
          medicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
          medicamentoInvalido: "Medicamento inválido",
          medicamentoRequerido: "Ingresa el código o nombre del medicamento",
          dosisCantidadRequerido: "Ingresa la cantidad",
          dosisCantidadMaximaLongitud: "Cantidad inválida",
          dosisCantidadInvalido: "Cantidad inválida",
          dosisUnidadesRequerido: "Seleccione unidad de dosis",
          viaAdministracionRequerido: "Seleccione vía administración",
          frecuenciaRequerido: "Seleccione frecuencia",
          duracionRequerido: "Ingresa la duración",
          duracionInvalido: "Duración inválida",
          duracionMin: "Duración minima de 1 dosis",
          duracionMax: "Duración máxima de 360 dosis",
          diluyenteRequerido: "Ingrese diluyente",
          diluyenteOpcionRequerido: "Seleccione una opción",
          diluyenteCantidadRequerido: "Ingresa la cantidad",
          diluyenteCantidadMaximaLongitud: "Cantidad inválida",
          diluyenteCantidadInvalido: "Cantidad inválida",
          codigoOxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
          codigoOxigenoInvalido: "Código inválido",
          oxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
          oxigenoInvalido: "Oxigeno inválido",
          oxigenoRequerido: "Ingresa el código o nombre del medicamento",
          fechaUltimaAplicacionRequerido: "Ingrese fecha de última aplicación",
          fechaInicioTratamientoRequerido: "Ingrese fecha",
          tipoNutricionRequerido: "Seleccione tipo nutrición",
          nutricionOpcionRequerido: "Seleccione una opción",
          unidadDosisNull:
            "Ocurrió un error al generar el medicamento, por favor vuelva a diligenciarlo. Medicamento: ",
        },
        opcionesMenu: {
          medicamentos: "Medicamentos",
          nebulizaciones: "Nebulizaciones",
          oxigenoterapia: "Oxigenoterapia",
          soporteNutricional: "Soporte nutricional",
        },
        tituloVentana: {
          agregarEditarMedicamentos: "Agregar / Editar Medicamentos",
          agregarEditarNebulizaciones: "Agregar / Editar Nebulizaciones",
          agregarEditarOxigeno: "Agregar / Editar Oxigeno",
          agregarEditarSoporteNutricional:
            "Agregar / Editar Soporte Nutricional",
        },
        botones: {
          cancelar: "Cancelar",
          guardar: "Guardar",
          agregar: "Agregar",
          editar: "Editar",
        },
        urls: {
          urlNoPBS:
            "https://mipres.sispro.gov.co/MIPRESNOPBS/Login.aspx?ReturnUrl=%2fMIPRESNOPBS%2fExito.aspx",
        },
        mensajesAlerta: {
         
          noDosisFaltantesMedicamentos:
            "Ha ocurrido un error al calcular las dosis faltantes en algunos medicamentos, por favor ingrese las dosis manualmente",
          noFototerapia:
            "La cita de Educación Fototerapia requiere un procedimiento de Fototerapia",
          noOxigeno:
            "La cita de Educación Oxigenoterapia requiere un tratamiento de OXIGENO",
          noNebulizacion:
            "La cita de Educación Nebulización requiere un tratamiento de NEBULIZACION",
          sinMedicamento:
            "Hay una Educación Nebulización sin medicamento, por favor edítela",
        },
      },

      valoraciones: {
        tipos: {
          poliza: "poliza",
          ingresoPolizaVida: "Ingreso Póliza de Vida",
        },
        identificadores: {
          ingresoPolizaVida: "4",
          fonoaudiologiaCanguro: "24",
          enfermeriaCanguro: "9",
        },
      },

      procedimientos: {
        campos: {
        profesional: "Profesional",
        tipo: "Tipo",
        tipoAtencion: {
          valoracion: "Valoración",
          codigoValoracion: "1",
          manejo: "Manejo",
          codigoManejo: "2",
        },
        recursoPreferido: "Profesional requerido",
        tipoCita: "Tipo cita",
        tipoFechaCita: {
          citaExistente: "Cita Existente",
          codigoCitaExistente: "1",
          fija: "Fija",
          codigoFija: "2",
          periodica: "Periodica",
          codigoPeriodica: "3",
        },
        fecha: "Fecha",
        fechaFija: "Fecha fija",
        fechaPeriodica: "Fecha periódica",
        fechaPeriodicaDoceHoras: "Control telefónico dos veces al día",
        semanas: "Semanas",
        totalVisitas: "Total visitas",
        programacionSemanal: "Días de la semana",
        minimoTotalVisitas: 1,
        maximoTotalVisitas: 30,
        tipoCambioCita: "Acción",
        fechaCita: "Fecha cita",
        especialidad: "Especialidad",
      },
      errores: {
        profesionalRequerido: "Seleccione profesional",
        tipoRequerido: "Seleccione tipo",
        tipoCitaRequerido: "Seleccione tipo cita",
        citaExistenteRequerido: "Seleccione cita existente",
        fechaFijaRequerido: "Ingresa fecha fija",
        fechaPeriodicaRequerido: "Ingresa fecha periódica",
        diasFechaPeriodicaRequerido: "Ingrese días",
        diasFechaPeriodicaMinimoValor: "Minimo 1 día",
        diasFechaPeriodicaMaximoValor: "Máximo 7 días",
        diasFechaPeriodicaInvalido: "Día inválido",
        totalSesionesRequerido: "Ingrese total de visitas",
        totalSesionesMinimoValor: "Minimo 1 total de visitas",
        totalSesionesMaximoValor: "Máximo 30 total de visitas",
        totalSesionesInvalido: "Total visitas inválido",
        semanasRequerido: "Ingrese semanas",
        semanasMinimoValor: "Minimo 1 semana",
        semanasMaximoValor: "Máximo 52 semanas",
        semanasInvalido: "Semanas inválida",
        tipoCambioCitaRequerido: "Seleccione tipo de cambio",
        fechaCitaRequerido: "Ingresa fecha cita",
        recursoPreferido: "Debe elegir un recurso requerido",
        frecuenciaRequerido: "Debe elegir una frecuencia",
        programacionSemanalRequerido: "Seleccione al menos un día de la semana",
      },
      tablaProgramacionSemanal: {
        noDias: "No se presentan días para la programación",
        seleccionDias: "Seleccione al menos un día de la semana",
      },
        curaciones: {
          campos: {
            tipoCuracion: "Tipo curación",
            diasSemana: "Días de la semana",
            sesiones: "Sesiones",
            descripcion: "Descripción",
            fechaInicioPrestacion: "Fecha inicio prestacion",
            fechaProximaDosis: "Fecha proxima dosis",
            fechaCuraciones: "Fecha",
            tiempoCuracion: "Tiempo de curación",
            tiempo30: "30 min",
            tiempo45: "45 min",
            tiempo60: "60 min",
            tiempo90: "90 min",
            tiempo120: "120 min",
          },
          errores: {
            tipoCuracionRequerido: "Seleccione el tipo de curación",
            seleccionDiasRequerido: "Seleccione al menos un día de la semana",
            sesionesCantidadRequerido: "Ingresa la cantidad",
            sesionesCantidadInvalido: "Cantidad inválida",
            sesionesCantidadMinima: "Mínimo 1 sesión",
            sesionesCantidadMaxima: "Máximo 99 sesiones",
            descripcionRequerido: "Ingresa la descripción",
            descripcionMaximaLongitud: "Cantidad inválida",
            fechaRequerido: "Ingrese fecha",
            tiempoRequerido: "Ingrese tiempo de curación"
          },
          tabla: {
            estado: "Estado",
            tipoCuracionCampo: "tipoCuracionDescripcion",
            tipoCuracion: "Tipo curación",
            diasSemanaCampo: "dias",
            diasSemana: "Días de la semana",
            sesionesCampo: "sesiones",
            sesiones: "Sesiones",
            dosisFaltantesCampo: "dosis faltantes",
            dosisFaltantes: "Dosis faltantes",
            fechaProximaDosisCampo: "fecha proxima dosis",
            fechaProximaDosis: "Fecha proxima dosis",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            noDias: "No han cargado los días de curaciones",
            noCuraciones: "No se han agregado curaciones",
            totalRegistros: "Total registros: ",
          },
          mensajesAlerta: {
            noDiasCuraciones:
              "Favor verifique la selección de días en cada una de las curaciones",
          },
        },

        sondajes: {
          campos: {
            tipoSondajeNovedades: "Tipo de sondaje",
            sondaje: "Sondaje",
            fechaSondaje: "Fecha inicio prestación",
            fechaProximaDosis: "Fecha próxima dosis",
            sesionesSondaje: "Sesiones",
          },
          errores: {
            tipoSondajeRequerido: "Seleccione tipo sondaje",
            sondajeRequerido: "Seleccione sondaje",
            fechaRequerido: "Ingrese fecha",
            sesionesRequerido: "Ingrese sesiones",
            sesionesInvalido: "Cantidad inválida",
          },
          tabla: {
            estado: "Estado",
            tipoSondajeCampo: "idTipoSondaje",
            tipoSondajeNovedades: "Tipo sondaje",
            sondajeCampo: "sondaje",
            sondaje: "Sondaje",
            fechaSondajeCampo: "fechaSondaje",
            fechaSondaje: "Fecha sondaje",
            totalSesionesCampo: "totalSesiones",
            totalSesiones: "Sesiones",
            dosisFaltantesCampo: "dosis faltantes",
            dosisFaltantes: "Dosis faltantes",
            fechaProximaDosisCampo: "fecha proxima dosis",
            fechaProximaDosis: "Fecha proxima dosis",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            noSondajes: "No se han agregado sondajes",
            totalRegistros: "Total registros: ",
          },
          tipos: {
            drenaje: "DRENAJE",
            alimentacion: "ALIMENTACION",
            tomaMuestra: "TOMAMUESTRA",
            evacuacion: "EVACUACION",
          },
        },

        fototerapias: {
          campos: {
            diasTratamiento: "Días de tratamiento",
            bilirrubinaTotal: "Bilirrubina total",
            ultimaTomaMuestra: "Última toma de muestra",
            tipoFrecuencia: "Tipos frecuencia",
            fechaInicioPrestacion: "Fecha inicio prestacion",
            fechaProximaDosis: "Fecha próxima dosis",
          },
          errores: {
            diasTratamientoRequerido: "Ingrese días de tratamiento",
            diasTratamientoMinimoValor: "Minimo 1 día de tratamiento",
            diasTratamientoMaximoValor: "Máximo 5 días de tratamiento",
            diasTratamientoInvalido: "Días de tratamiento inválido",
            tipoFrecuenciaRequerido: "Seleccione el tipo de frecuencia",
          },
          tabla: {
            estado: "Estado",
            diasTratamientoCampo: "diasTratamiento",
            diasTratamiento: "Días de tratamiento",
            tipoFrecuenciaCampo: "tipoFrecuencia",
            tipoFrecuencia: "Tipo frecuencia",
            fechaInicioPrestacionCampo: "fechaInicioPrestacion",
            fechaInicioPrestacion: "FechaInicioPrestacion",
            fechaProximaDosisCampo: "fechaProximaDosis",
            fechaProximaDosis: "FechaProximaDosis",
            dosisFaltantesCampo: "dosisFaltantes",
            dosisFaltantes: "DosisFaltantes",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            noFototerapias: "No se han agregado fototerapias",
            totalRegistros: "Total registros: ",
          },
        },

        tomaMuestra: {
          campos: {
            tipoMuestra: "Tipo toma de muestra",
            fechaMuestra: "Fecha inicio prestación",
            fechaProximaDosis: "Fecha próxima sesión",
            requiereAyuno: "Requiere ayuno",
          },
          errores: {
            tipoMuestraRequerido: "Seleccione el tipo de muestra",
            fechaRequerido: "Ingrese la fecha",
            campoRequerido: "Selecciona una opción",
          },
          tabla: {
            estado: "Estado",
            tipoMuestraCampo: "tipoMuestraDescripcion",
            tipoMuestra: "Tipo toma de muestra",
            fechaMuestraCampo: "fechaMuestra",
            fechaMuestra: "Fecha de toma de muestra",
            requiereAyunoCampo: "requiereAyuno",
            requiereAyuno: "Requiere ayuno",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            sesionesCampo: "sesiones",
            sesiones: "Sesiones",
            dosisFaltantesCampo: "sesiones faltantes",
            dosisFaltantes: "Dosis faltantes",
            fechaProximaDosis: "Fecha próxima sesión",
            fechaProximaDosisCampo: "fecha próxima sesión",
            noTomaMuestras: "No se han agregado toma de muestras",
            totalRegistros: "Total registros: ",
          },
        },

        secreciones: {
          campos: {
            diasTratamiento: "Días de tratamiento",
            envioAspirador: "Envío de aspirador",
            visitaEnfermeria: "Visita de enfermería",
            tipoSonda: "¿Tipo de sonda? *",
            pediatrica: "Pediatrica",
            adulto: "Adulto",
            yankauer: "Yankauer",
            via: "Via",
            nasal: "Nasal",
            traqueostomia: "Traqueostomía",
            fechaInicioPrestacion: "Fecha inicio prestación",
            fechaProximaDosis: "Fecha próxima sesión",
          },
          errores: {
            diasTratamientoRequerido: "Ingrese días de tratamiento",
            diasTratamientoMinimoValor: "Minimo 1 día de tratamiento",
            diasTratamientoMaximoValor: "Máximo 30 días de tratamiento",
            diasTratamientoInvalido: "Días de tratamiento inválido",
            tipoSondaRequerido: "Seleccione el tipo de sonda",
            fechaRequerido: "Ingrese la fecha",
          },
          tabla: {
            estado: "Estado",
            diasTratamientoCampo: "diasTratamiento",
            diasTratamiento: "Días de tratamiento",
            envioAspiradorCampo: "envioAspirador",
            envioAspirador: "Envío de aspirador",
            visitaEnfermeriaCampo: "visitaEnfermeria",
            visitaEnfermeria: "Visita de enfermería",
            tipoSondaCampo: "tipoSonda",
            tipoSonda: "Tipo de sonda",
            nasalCampo: "nasal",
            nasal: "Nasal",
            traqueostomiaCampo: "traqueostomia",
            traqueostomia: "Traqueostomía",
            dosisFaltantesCampo: "sesiones faltantes",
            dosisFaltantes: "Sesiones faltantes",
            fechaProximaDosisCampo: "fecha proxima dosis",
            fechaProximaDosis: "Fecha proxima dosis",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            noSecreciones: "No se han agregado aspiraciones de secreciones",
            totalRegistros: "Total registros: ",
          },
        },

        canalizaciones: {
          campos: {
            intravenosa: "Intravenosa",
            subcutanea: "Subcutánea",
            tipoCanalizacion: "Tipo de canalización",
            fechaInicioPrestacion: "Fecha inicio prestación",
            fechaProximaDosis: "Fecha próxima sesión",
          },
          errores: {
            tipoCanalizacionRequerido: "Seleccione el tipo de canalización",
            fechaRequerido: "Ingrese la fecha",
          },
          tabla: {
            estado: "Estado",
            tipoCanalizacionCampo: "tipoCanalizacion",
            tipoCanalizacion: "Tipo de canalización",
            dosisFaltantesCampo: "sesiones faltantes",
            dosisFaltantes: "Sesiones faltantes",
            fechaProximaDosisCampo: "fecha proxima sesion",
            fechaProximaDosis: "Fecha proxima sesion",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            noCanalizaciones: "No se han agregado canalizaciones",
            totalRegistros: "Total registros: ",
          },
        },

        soporteNutricional: {
          campos: {
            medicamento: "Medicamento",
            medicamentoCodigo: "Código",
            medicamentoNombre: "Nombre",
            medicamentoBuscar: "Buscar por código o nombre",
            dosis: "Cantidad",
            dosisUnidades: "Unidades",
            tipoNutricion: "Tipo nutrición",
            nutricion: "Nutrición",
            frecuencia: "Frecuencia",
            frecuenciaSeleccionar: "Seleccionar",
            duracion: "Tiempo infusión",
            duracionCantidad: "Cantidad",
            duracionDosis: "Dosis",
            dosisFaltantes: "Dosis faltantes",
            noPBS: "No PBS",
            diasTratamiento: "Días tratamiento",
            volumen: "Volumen (gr)",
            diasEvento: "Dias",
            horaEvento: "Hora",
            fechaInicioPrestacion: "Fecha inicio prestación",
            fechaProximaDosis: "Fecha próxima sesión",
            mipresRequerido: "Medicamento requiere registro Mipres"
          },
          errores: {
            codigoMedicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
            codigoMedicamentoInvalido: "Código inválido",
            medicamentoMaximaLongitud: "Máxima longitud 10 dígitos",
            medicamentoInvalido: "Medicamento inválido",
            medicamentoRequerido: "Ingresa el código o nombre del medicamento",
            dosisCantidadRequerido: "Ingresa la cantidad",
            dosisCantidadMaximaLongitud: "Cantidad inválida",
            dosisCantidadInvalido: "Cantidad inválida",
            dosisUnidadesRequerido: "Seleccione unidad de dosis",
            viaAdministracionRequerido: "Seleccione vía administración",
            frecuenciaRequerido: "Seleccione frecuencia",
            duracionRequerido: "Ingrese el tiempo",
            duracionInvalido: "Tiempo inválido",
            duracionMin: "Tiempo minimo de 1",
            duracionMax: "Tiempo máximo de 999",
            diasTratamientoRequerido: "Ingresa la cantidad",
            diasTratamientoInvalido: "Cantidad inválida",
            diasTratamientoMin: "Minimo 1 día",
            diasTratamientoMax: "Máximo 99 días",
            volumenRequerido: "Ingresa la cantidad",
            volumenInvalido: "Volumen inválido",
            volumenMin: "Minimo 1 gr",
            volumenMax: "Máximo 9000 gr",
            diluyenteRequerido: "Ingrese diluyente",
            diluyenteOpcionRequerido: "Seleccione una opción",
            diluyenteCantidadRequerido: "Ingresa la cantidad",
            diluyenteCantidadMaximaLongitud: "Cantidad inválida",
            diluyenteCantidadInvalido: "Cantidad inválida",
            codigoOxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
            codigoOxigenoInvalido: "Código inválido",
            oxigenoMaximaLongitud: "Máxima longitud 10 dígitos",
            oxigenoInvalido: "Oxigeno inválido",
            oxigenoRequerido: "Ingresa el código o nombre del medicamento",
            fechaUltimaAplicacionRequerido:
              "Ingrese fecha de última aplicación",
            fechaRequerido: "Ingrese fecha",
            tipoNutricionRequerido: "Seleccione tipo nutrición",
            nutricionRequerido: "Seleccione nutricion",
            diasEventoRequerido: "Seleccione el día",
            horaEventoRequerido: "Seleccione la hora",
            tipoEventoRequerido: "Seleccione el tipo",
            eventoRequerido: "Agrega al menos un evento",
          },
          tabla: {
            id: "id",
            estado: "Estado",
            medicamentoCampo: "medicamentoDescripcion",
            medicamento: "Medicamento",
            dosisCampo: "cantidadDosis",
            dosis: "Dosis",
            tipoNutricionCampo: "tipoNutricionDescripcion",
            tipoNutricion: "Tipo nutrición",
            nutricionCampo: "nutricionDescripcion",
            nutricion: "Nutrición",
            frecuenciaCampo: "frecuenciaDescripcion",
            frecuencia: "Frecuencia",
            duracionCampo: "duracion",
            duracion: "Duración",
            noPBSCampo: "noPBS",
            noPBS: "No PBS",
            diasCampo: "diasEvento",
            dias: "Días",
            horaCampo: "frecuenciaDescripcion",
            hora: "Hora",
            eventoCampo: "eventoDescripcion",
            evento: "Evento",
            diasTratamientoCampo: "diasTratamiento",
            diasTratamiento: "Días tratamiento",
            fechaInicioPrestacion: "Fecha inicio prestación",
            fechaProximaDosis: "Fecha próxima sesión",
            dosisFaltantes: "Dosis faltantes",
            accion: "Acciones",
            eliminar: "Eliminar",
            editar: "Editar",
            noSoporteNutricional: "El paciente no tiene soporte nutricional",
            noEventos: "No se han agregado eventos",
            totalRegistros: "Total registros: ",
          },
          tiposNutricion: {
            enteral: "Enteral",
            parenteral: "Parenteral",
          },
        },

        opcionesMenu: {
          curaciones: "Curaciones",
          sondajes: "Sondajes",
          terapias: "Terapias",
          fototerapias: "Fototerapias",
          tomaMuestras: "Toma de muestras",
          secreciones: "Secreciones",
          canalizaciones: "Canalizaciones",
          soporteNutricional: "Soporte nutricional",
        },
        tituloVentana: {
          agregarEditarCuraciones: "Agregar / Editar Curaciones",
          agregarEditarSondajes: "Agregar / Editar Sondajes",
          agregarEditarTerapias: "Agregar / Editar Terapias",
          agregarEditarFototerapias: "Agregar / Editar Fototerapias",
          agregarEditarTomaMuestras: "Agregar / Editar Toma de muestras",
          agregarEditarAspiracionSecreciones:
            "Agregar / Editar Aspiración de secreciones",
          agregarEditarCanalizaciones: "Agregar / Editar Canalizaciones",
          agregarEditarSoporteNutricional:
            "Agregar / Editar Soporte nutricional",
        },
        botones: {
          cancelar: "Cancelar",
          guardar: "Guardar",
          agregar: "Agregar",
          editar: "Editar",
        },
        urls: {
          urlNoPBS:
            "https://mipres.sispro.gov.co/MIPRESNOPBS/Login.aspx?ReturnUrl=%2fMIPRESNOPBS%2fExito.aspx",
        },
      },

      procediemientoImagenesDiagnosticas: {
        imagenesDiagnosticas: {
          campos: {
            imagenesDiagnosticas: "Imágenes Diagnosticas",
            detalleImagen: "detalle de la imágen diagnostica",
          },
          errores: {
            imagenDiagnosticaRequerido: "Seleccione una imágen diagnostica",
            detalleImagen: "Ingrese detalle de la imágen",
          },
          opcionesMenu: {
            ImagenesDiagnosticas: "Imágenes diagnosticas",
          },
          tabla: {
            nombreImagenCampo: "NombreImagen",
            nombreImagen: "Nombre de imagen",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
          },
          tituloVentana: {
            agregarEditarImagenesDiagnosticas:
              "Agregar / Editar Imágenes diagnosticas",
          },
          botones: {
            cancelar: "Cancelar",
            guardar: "Guardar",
            agregar: "Agregar",
            editar: "Editar",
          },
        },
      },
    },

    citas: {
      campos: {
        profesional: "Profesional",
        tipo: "Tipo",
        tipoAtencion: {
          valoracion: "Valoración",
          codigoValoracion: "1",
          manejo: "Manejo",
          codigoManejo: "2",
        },
        recursoPreferido: "Profesional requerido",
        tipoCita: "Tipo cita",
        tipoFechaCita: {
          citaExistente: "Cita Existente",
          codigoCitaExistente: "1",
          fija: "Fija",
          codigoFija: "2",
          periodica: "Periodica",
          codigoPeriodica: "3",
        },
        fecha: "Fecha",
        fechaFija: "Fecha fija",
        fechaPeriodica: "Fecha periódica",
        fechaPeriodicaDoceHoras: "Control telefónico dos veces al día",
        semanas: "Semanas",
        totalVisitas: "Total visitas",
        programacionSemanal: "Días de la semana",
        minimoTotalVisitas: 1,
        maximoTotalVisitas: 30,
        tipoCambioCita: "Acción",
        fechaCita: "Fecha cita",
        especialidad: "Especialidad",
      },
      errores: {
        profesionalRequerido: "Seleccione profesional",
        tipoRequerido: "Seleccione tipo",
        tipoCitaRequerido: "Seleccione tipo cita",
        citaExistenteRequerido: "Seleccione cita existente",
        fechaFijaRequerido: "Ingresa fecha fija",
        fechaPeriodicaRequerido: "Ingresa fecha periódica",
        diasFechaPeriodicaRequerido: "Ingrese días",
        diasFechaPeriodicaMinimoValor: "Minimo 1 día",
        diasFechaPeriodicaMaximoValor: "Máximo 7 días",
        diasFechaPeriodicaInvalido: "Día inválido",
        totalSesionesRequerido: "Ingrese total de visitas",
        totalSesionesMinimoValor: "Minimo 1 total de visitas",
        totalSesionesMaximoValor: "Máximo 30 total de visitas",
        totalSesionesInvalido: "Total visitas inválido",
        semanasRequerido: "Ingrese semanas",
        semanasMinimoValor: "Minimo 1 semana",
        semanasMaximoValor: "Máximo 52 semanas",
        semanasInvalido: "Semanas inválida",
        tipoCambioCitaRequerido: "Seleccione tipo de cambio",
        fechaCitaRequerido: "Ingresa fecha cita",
        recursoPreferido: "Debe elegir un recurso requerido",
        frecuenciaRequerido: "Debe elegir una frecuencia",
      },
      tabla: {
        especialidadCampo: "profesional",
        especialidad: "Especialidad",
        estadoCampo: "estado",
        estado: "Estado",
        tipoCitaCampo: "tipoCita",
        tipoCita: "Tipo de cita",
        profesionalCampo: "profesional",
        profesional: "Profesional",
        fechaCampo: "fecha",
        fecha: "Fecha",
        totalSesionesCampo: "totalSesiones",
        totalSesiones: "Total sesiones",
        sesionesFaltantesCampo: "sesionesFaltantes",
        sesionesFaltantes: "Sesiones faltantes",
        accion: "Acción",
        editar: "Editar",
        eliminar: "Eliminar",
        noCitas: "No se presentan citas registradas",
        tituloEliminarCita: "Eliminar cita",
        contenidoEliminarCita: "¿Está seguro de eliminar la cita?",
        validaciones: {
          cantidadSesiones: "Mínimo 1 sesión y máximo 2 sesiones por día",
          seleccionDias: "Seleccione al menos un dia",
          valorInvalido: "Inválido",
        },
        sesiones: "Sesiones",
        noDias: "No se presentan días para la programación",
        totalRegistros: "Total registros: ",
      },
      titulos: {
        citas: "Citas",
        agregarCita: "Agregar cita",
        reprogramarCita: "Reprogramar cita",
      },
      opcionesMenu: {
        citas: "Citas",
        agregarReprogramar: "Agregar/Reprogramar cita",
      },
      profesiones: {
        enfermeria: {
          id: "4",
          nombre: "Enfermeria",
          auxiliarEnfermeria: "Auxiliar Enfermería",
          tiposCita: {
            idRetiroMedicamentos: "39",
            idHeridaMayor: "9",
            idHeridaMenor: "10",
            idEducacionNebulizacion: '15',
            heridaMayor: "Herida mayor",
            heridaMenor: "Herida menor",
            retiroMedicamentos: "RetiroMedicamentos",
            ducacionNebulizacion: 'Educacion Nebulizacion',
          },
        },
        auxiliarEnfermeria: {
          id: "19",
        },
        jefeEnfermeria: {
          id: "20",
        },
      },
      tituloVentana: {
        agregarEditarCitas: "Agregar / Editar Citas",
        agregarReprogramarCita: "Adicionar / Reprogramar cita",
        contenidoAgregarReprogramarCita:
          "El plan de manejo ha sido modificado, si hace clic en Aceptar se perderán los cambios",
      },
      botones: {
        editar: "Editar",
        eliminar: "Eliminar",
        cancelar: "Cancelar",
        guardar: "Guardar",
        agregarCita: "Agregar cita",
        guardarCitas: "Guardar citas",
        agregar: "Agregar",
        adicionarReprogramar: "Adicionar o Reprogramar",
        reprogramar: "Reprogramar",
        restaurar: "Restaurar",
      },
      mensajesAlerta: {
        exitoCambioCita: "Novedad enviada a gestión exitosamente",
        errorCambioCita: "Ha ocurrido un error, favor intente más tarde",
        errorCargarCita:
          "Ha ocurrido un error al cargar las citas, favor intente más tarde",
        noCambioCita: "No se ha presentado modificación de citas",
        citaProfesionalDuplicado:
          "Ya existe una cita para el tipo de profesional",
        citaSinCuracion:
          "El paciente debe tener un procedimiento de Curación Mayor para generar esta cita",
        existeTratamientoOxigeno:
          "Ya existe un tratamiento de tipo OXIGENO, por favor edítelo",
        existeProcesimientoFototerapia:
          "Ya existe un procedimiento de tipo Fototerapia, por favor edítelo",
      },
      accionesAgregarReprogramar: {
        agregarCita: "Agregar cita",
        reprogramarCita: "Reprogramar cita",
      },
    },

    alertasVisitas: {
      procedimientos: {
        curaciones: {
          tabla: {
            tipoCuracion: "Tipo curación",
            diasSemana: "Días de la semana",
            sesiones: "Sesiones",
            dosisFaltantes: "Dosis Faltantes",
          },
        },
        sondajes: {
          tabla: {
            tipoSondaje: "Tipo sondaje",
            sondaje: "Sondaje",
            fechaSondaje: "Fecha sondaje",
            sesiones: "Sesiones",
            dosisFaltantes: "Dosis faltantes",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
          },
        },
        tomaMuestras: {
          tabla: {
            tipoMuestra: "Tipo toma de muestra",
            fecha: "Fecha de toma de muestra",
            requierAyuno: "Requiere ayuno",
            sesiones: "Sesiones",
            dosisFaltantes: "Dosis faltantes"
          },
        },
        secreciones: {
          tabla: {
            diasTratamiento: "Días de tratamiento",
            envioAspirador: "Envío de aspirador",
            visitaEnfermeria: "Visita de enfermería",
            tipoSonda: "Tipo de sonda",
            nasal: "Nasal",
            traqueostomia: "Traqueostomía",
            sesionesFaltantes: "Sesiones faltantes",
            fechaProximaDosis: "Fecha proxima dosis"
          },
        },
        canalizaciones: {
          tabla: {
            tipoCanalizacion: "Tipo de canalización",
            sesionesFaltantes: "Sesiones Faltantes",
            visitaEnfermeria: "Fecha proxima sesión",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            totalRegistros: "Total registros: ",
            noCanalizaciones: "No se han agregado canalizaciones",
          },
        },
        soporteNutricional: {
          tabla: {
            medicamento: "Medicamento",
            dosis: "Dosis",
            tipoNutricion: "Tipo nutrición",
            nutricion: "Nutrición",
            duracion: "Duración",
            fechaProximaSesion: "Fecha próxima sesión",
            dosisFaltantes: "Dosis faltantes",

          },
        },
        fototerapia: {
          tabla: {
            diasTratemiento: "Días de tratamiento",
            tipoFrecuencia: "Tipo frecuencia",
            dosisFaltantes: "Dosis faltantes",
            accion: "Acción",
            editar: "Editar",
            eliminar: "Eliminar",
            totalRegistros: "Total registros: ",
            noCanalizaciones: "No se han agregado canalizaciones",
          },
        }
      },

      tratamiento: {
        tabla: {
          medicamento: "Medicamento",
          dosis: "Cantidad",
          viaAdministracion: "Via administración",
          frecuencia: "Frecuencia",
          duracion: "Duración",
          duracionDosis: "Dosis",
          dosisFaltantes: "Dosis faltantes",
          duracionDosisOxigeno: "Días",
        },
        campos: {
          duracionDosis: "Dosis",
          fechaProximaDosis: "Fecha proxima dosis"
        }
      },

      cita: {
        tabla: {
          tipoCita: "Tipo",
        },
      },

      acciones: {
        accion: "Acción",
        totalRegistros: "Total registros:",
        guardar: "Aplicar",
      },
    },

    modalAlertas: {
      campos: {
        subtittle: "¿ Deseas guardar los cambios realizados ?",
        titulo: "Debes guardar primero o se perdera la información",
      },
      botones: {
        cerrar: "NO",
        guardar: "SI",
      },
    },

    equipoBiomedico: {
      campos: {
        tipoEquipoBiomedico: "Equipo biomédico",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
        notaEliminar: "Nota",
        tituloModalEliminar: "Eliminar equipo biomédico",
        viaAdministracion: "Via administracion",
      },
      errores: {
        equipoBiomedicoRequerido: "Seleccione el equipo biomédico",
        fechaInicioRequerido: "Ingrese fecha inicio",
        fechaFinRequerido: "Ingrese fecha fin",
      },
      botones: {
        solicitar: "Solicitar",
        botonesGuardarEliminar: "Guardar",
        botonesCancelarEliminar: "Cancelar",
      },
      tabla: {
        equipoBiomedicoCampo: "equipoBiomedicoDescripcion",
        equipoBiomedico: "Equipo biomédico",
        fechaInicioCampo: "fechaInicio",
        fechaInicio: "Fecha inicio",
        fechaFinCampo: "fechaFin",
        fechaFin: "Fecha fin",
        estadoCampo: "estado",
        estado: "Estado",
        estadoProveedorCampo: "estadoProveedor",
        estadoProveedor: "Estado proveedor",
        accion: "Acción",
        editar: "Editar",
        eliminar: "Eliminar",
        guardar: "Guardar",
        noEquiposBiomedicos: "El paciente no tiene equipos biomédicos",
        totalRegistros: "Total registros: ",
      },
      mensajesAlerta: {
        exitoSolicitarEquipo:
          "Se ha solicitado equipos biomédicos exitosamente",
        errorSolicitarEquipo: "Ha ocurrido un error, favor intente más tarde",
        equipoExistente: "Ya se ha agregado este equipo biomédico",
      },
      equipos: {
        idEquipoCilindroPortatil: "8",
      },
      estados: {
        solicitado: "1",
        asignado: "2",
        entregado: "3",
        terminado: "4",
        cancelado: "5",
        devolucion_fallida: "13",
      },
    },

    gestionNovedad: {
      campos: {
        tipoDocumento: "Tipo documento",
        numeroDocumento: "Número documento",
        ciudad: "Ciudad",
        piso: "Piso",
        estado: "Estado",
        planesGestionados: "Mostrar planes de manejo gestionados",
        remision: "Remision",
        usuario: "Usuario",
        programa: "Programa",
        clasificacionPermanente: "Clasificación",
        tipoNovedad: "Tipo Novedad",
        especialidadCita: "Especialidad Cita",
      },
      errores: {
        ciudadRequerido: "Seleccione la ciudad",
        numeroDocumentoMaximaLongitud: "Máximo 20 caracteres",
        numeroDocumentoInvalido: "Número de documento inválido",
      },
      tabla: {
        fechaGestionCampo: "fechaGestionSolicitud",
        fechaGestion: "Fecha gestión",
        usuarioGestionCampo: "usuarioGestion",
        usuarioGestion: "Usuario gestiona",
        tipoNovedadCampo: "tipoNovedad",
        tipoNovedad: "Tipo novedad",
        nombrePacienteCampo: "nombrePaciente",
        nombrePaciente: "Paciente",
        numeroIdentificacionCampo: "numeroIdentificacion",
        numeroIdentificacion: "Identificación",
        pisoCampo: "piso",
        piso: "Piso",
        usuarioReportaCampo: "usuarioSolicita",
        usuarioReporta: "Usuario reporta",
        fechaSolicitudCampo: "fechaSolicitud",
        fechaSolicitud: "Fecha novedad",
        estadoSolicitudNovedadCampo: "estadoSolicitudNovedad",
        estadoSolicitudNovedad: "Estado",
        accion: "Acción",
        gestionar: "Gestionar",
        noNovedades:
          "No se presentan novedades relacionadas a los criterios de búsqueda",
        totalRegistros: "Total registros: ",
        tituloGestionarNovedadActivacion: "Gestionar solicitud",
        contenidoGestionarNovedadActivacion:
          "¿Está seguro de gestionar esta solicitud de novedad tipo Activación?",
      },
      titulos: {
        gestionarNovedades: "Gestionar novedades",
      },
      botones: {
        limpiar: "Limpiar",
        buscar: "Buscar",
        guardarFiltros: "Guardar filtros",
      },
      mensajesAlerta: {
        errorGestionNovedades:
          "No hay novedades relacionados a los criterios de búsqueda",
        exitoGestionarSolicitud:
          "Se ha gestionado la solicitud de novedad exitosamente",
        errorGestionarSolicitud:
          "Ha ocurrido un error, favor intente más tarde",
      },
    },

    detalleGestionNovedad: {
      campos: {
        seleccionListaCita:
          "Seleccione la visita para aplicar el nuevo plan de manejo",
        seleccionFechaCita: "Ingrese una fecha y hora para aplicar la novedad",
        listaCita: "listaCita",
        fechaCita: "fechaCita",
        volverAtras: "Volver",
        verPlanesManejo: "Ver planes de manejo",
      },
      opciones: {
        volverAtras: "Volver",
        verPlanesManejo: "Ver planes de manejo",
      },
      titulos: {
        gestionarNovedades: "Gestionar novedades",
        usuarioRegistra: "Usuario registra",
        usuarioGestiona: "Usuario gestiona",
        profesionalAutoriza: "Autoriza",
      },
      tabla: {
        idNovedadCampo: "id",
        idNovedad: "Id",
        estadoCampo: "estado",
        estado: "Estado",
        novedadCampo: "novedad",
        novedad: "Novedad",
        visitaCampo: "especialidad",
        visita: "Visita",
        fechaCampo: "fechaInicioCita",
        fecha: "Fecha",
        noNovedades: "No se presentan novedades",
        noCitas: "No se presentan citas",
        detalle: "Detalle",
        visualizar: "Visualizar",
        totalRegistros: "Total registros: ",
      },
      validaciones: {
        fechaRequerido: "Ingrese fecha",
      },
      botones: {
        gestionar: "Gestionar",
        escalar: "Escalar",
        cancelar: "Cancelar",
        aplicar: "Aplicar",
        ActualizarSolicitud: "Actualizar solicitud",
      },
      mensajesAlerta: {
        exitoEscalarSolicitud:
          "Se ha escalado la solicitud de novedad exitosamente",
        errorEscalarSolicitud: "Ha ocurrido un error, favor intente más tarde",
        exitoGestionarSolicitud:
          "Se ha gestionado la solicitud de novedad exitosamente",
        errorGestionarSolicitud:
          "Ha ocurrido un error, favor intente más tarde",
      },
      tipoCita: {
        retiroMedicamentos: "Retiro de medicamentos",
      },
    },

    detallesGestionNovedadesCampos: {
      diagnosticos: {
        codigo: "Codigo",
        nombre: "Nombre diagnostico",
      },

      AlertaCita: {
        textoAlerta: "Nombre alerta",
        duracion: "Duracion",
      },

      equipoBiomedico: {
        tipoEquipo: "Tipo de equipo",
        estado: "Estado",
        proveedor: "Proveedor",
      },

      cancelarCita: {
        especialidad: "Especialidad",
        motivo: "Motivo de cancelacion",
        observacion: "Observacion",
      },

      aplicacionCuidador: {
        especialidad: "Especialidad",
        motivo: "Motivo",
        fechaInicioCita: "Fecha de inicio cita",
        horaInicioCita: "Hora de inicio",
      },

      fijarCita: {
        especialidad: "Especialidad",
        fechaInicioCita: "Fecha de inicio cita",
        horaFijadaInicio: "Inicio de hora fijada",
        horaFijadaFin: "Fin de hora fijada",
      },

      desfijarCita: {
        especialidad: "Especialidad",
        fechaInicioCita: "Fecha Inicio cita",
      },

      profesionalAsignado: {
        especialidad: "Especialidad",
        nombreCompleto: "Nombre completo",
        region: "Region",
        distrito: "Distrito",
        direccion: "Direccion",
      },
    },

    gestionPaciente: {
      campos: {
        tipoDocumento: "Tipo documento",
        numeroDocumento: "Número documento",
        ciudad: "Ciudad",
        piso: "Piso",
        estado: "Estado",
        planesGestionados: "Mostrar planes de manejo gestionados",
        consultaPacientes: "Consultar pacientes en: ",
        activos: "Activos: ",
        nuevo: "Nuevo: ",
        preAlta: "Pre-alta: ",
        alta: "Alta: ",
        programa: "Programa",
      },
      errores: {
        ciudadRequerido: "Seleccione la ciudad",
        numeroDocumentoMaximaLongitud: "Máximo 20 caracteres",
        numeroDocumentoInvalido: "Número de documento inválido",
      },
      tabla: {
        remisionCampo: "idRemision",
        remision: "Remisión",
        identificacionCampo: "identificacion",
        identificacion: "Identificación",
        pacienteCampo: "nombre",
        paciente: "Paciente",
        resumenRemisionCampo: "resumenRemision",
        resumenRemision: "Resumen remisión",
        novedadCampo: "novedad",
        novedad: "Novedad",
        equipoBiomedicoCampo: "equipoBiomedico",
        equipoBiomedico: "Equipo biomédico",
        estadoCampo: "estadoPaciente",
        estado: "Estado",
        accion: "Acción",
        gestionar: "Gestionar",
        noPacientes:
          "No se presentan pacientes relacionados a los criterios de búsqueda",
        totalRegistros: "Total registros: ",
        linkHistorial: "Historial",
        linkGestionar: "Gestionar",
        linkCrearNovedad: "Crear",
        linkEquipoBiomedico: "Ir",
        fechaAdmisionCampo: "fechaAdmision",
        fechaAdmision: "Fecha de Admisión",
        fechaPosibleAltaCampo: "fechaPosibleAlta",
        fechaPosibleAlta: "Fecha de Posible Alta",
      },
      titulos: {
        gestionarPacientes: "Gestionar pacientes",
      },
      botones: {
        limpiar: "Limpiar",
        buscar: "Buscar",
        guardarFiltros: "Guardar filtros",
      },
      mensajesAlerta: {
        errorCargarGestionPacientes:
          "No hay pacientes relacionados a los criterios de búsqueda",
      },
    },

    historialPlanManejo: {
      campos: {
        tipoDocumentoPaciente: "Tipo identificación",
        numeroDocumentoPaciente: "Número identificación",
        remisionPaciente: "Remisión",
        textoRemision: "Remisión: ",
        textoPaciente: "Paciente: ",
        programa: "Programa",
        piso: "Piso",
        accion: "Acción",
        nombre: "Paciente",
        obtener: "Ver plan manejo"
      },
      errores: {
        tipoDocumentoPacienteRequerido: "Seleccione el tipo",
        numeroDocumentoPacienteRequerido: "Ingresa el número",
        numeroDocumentoPacienteMaximaLongitud: "Máxima longitud 20 dígitos",
        numeroDocumentoPacienteInvalido: "Número inválido",
        remisionPacienteRequerido: "Ingresa el número de remisón",
        remisionPacienteMaximaLongitud: "Máxima longitud 15 dígitos",
        remisionPacienteInvalido: "Número inválido",
      },
      botones: {
        buscarPaciente: "Buscar paciente",
        volverAtras: "Volver",
      },
      titulos: {
        historialPlanManejo: "Historial Planes de Manejo",
        remisiones: "Remisiones",
        planesManejo: "Planes de manejo",
        egreso: "Novedad Egreso",
        infoPaciente: "Información Paciente",
        tratamientoProcedimiento: "Tratamientos y procedimientos",
        cita: "Citas",
        diagnosticos: "Diagnósticos",
        nombre: "Nombre ",
        tipoAfiliacion: "Afiliación ",
        edad: "Edad ",
        sexo: "Sexo ",
        programa: "Programa",
        piso: "Piso",
        paciente: "Paciente",
        remision: "Remisión",
        accion: "Acción"
      },
      tablaRemision: {
        remisionCampo: "idRemision",
        remision: "Remision",
        fechaCreacionCampo: "fechaCreacion",
        fechaCreacion: "Fecha creación",
        noRemisiones: "No se presentan remisiones",
      },
      tablaNovedad: {
        tipoNovedadCampo: "tipoNovedad",
        tipoNovedad: "Novedad",
        fechaCreacionNovedadCampo: "fechaCreacionNovedad",
        fechaCreacionNovedad: "Fecha creación",
        noNovedades: "No se presentan novedades",
      },

      validaciones: {
        noRemisionActiva:
          "No existe una remisión activa para la información ingresada",
      },
      mensajesAlerta: {
        errorHistorial: "Ha ocurrido un error, favor intente más tarde",
        noRemisiones: "El paciente no tiene remisiones en Salud en casa",
      },
    },

    modificacionVisitas: {
      campos: {
        formulario: "Seleccione formulario",
      },
      botones: {},
      formularios: {
        alertasVisitas: "Alertas en visita enfermería",
        alertasCitasMedicina:"Alertas en visita profesional",
        aplicacionesCuidador: "Aplicaciones cuidador",
        cancelarVisitas: "Cancelar visitas",
        fijarVisitas: "Fijar visitas",
      },
    },

    fijacionVisitas: {
      campos: {
        mensajeHoras: "Ingrese el rango de horas en que se realizará la visita",
        motivoFijacion: "Motivo fijación",
        especialidad: "Especialidad",
        horaFijada: "Hora fijada",
        horaInicial: "Hora inicial",
        horaFinal: "Hora final",
      },
      errores: {
        horaFijacionRequerido: "Seleccione hora",
        rangoHorasError: "El rango de horas es invalido",
        unaHora: "Debe haber una diferencia minima de una hora",
        motivoFijacionRequerido: "Seleccione el motivo",
      },
      botones: {
        fijar: "Fijar",
        desfijar: "Desfijar",
      },
      tabla: {
        fechaVisitaCampo: "fechaInicioCita",
        fechaVisita: "Fecha visita",
        motivoCampo: "motivoFijacion",
        motivo: "Motivo fijación",
        horaFijadoCampo: "horaFijado",
        horaFijado: "Rango de horas fijadas",
        especialidadCampo: "especialidad",
        especialidad: "Especialidad",
        visualizar: "Visualizar",
        noVisitas: "No se presentan visitas para los filtros seleccionados",
        totalRegistros: "Total registros: ",
      },
      mensajesAlerta: {
        exitoFijarVisita: "Se han fijado las visitas exitosamente",
        exitoDesFijarVisita: "Se han desfijado las visitas exitosamente",
        errorFijarDesfijarVisita:
          "Ha ocurrido un error, favor intente más tarde",
      },
    },
    calendarios: {
      titulos: {
        calendarios: "Calendarios",
      },
      tabla: {},
    },
  },

  lineaUnica: {
    campos: {
      ciudad: "Ciudad",
      nroDocumento: "Numero de documento",
      piso: "Piso",
      planSalud: "Plan de salud",
      tipoPlanSalud: "Tipo de plan de salud",
      contactos: "Número de contactos",
      fechaInicio: "Fecha inicio de admisión ",
      fechaFinalizacion: "Fecha de finalización",
      horaAdmision: "Hora de admisión",
      programa: "Programa",
      estado: "Estado",
    },
    tabla: {
      numeroRemision: "Remisión",
      fechaAdmisionCampo: "fechaRemision",
      fechaAdmision: "Fecha Admisión",
      usuarioCampo: "usuario",
      usuario: "Usuario",
      nombrePacienteCampo: "nombrePaciente",
      nombrePaciente: "Paciente",
      planSaludCampo: "planSalud",
      planSalud: "Plan salud",
      tipoPlanParticularCampo: "tipoPlanParticular",
      tipoPlanParticular: "Tipo Plan Salud",
      programaCampo: "programa",
      programa: "Programa",
      pisoCampo: "piso",
      piso: "Piso",
      contactoCampo: "contacto",
      contacto: "Contactos",
      estadoRemisionCampo: "estadoRemision",
      estadoRemision: "Estado",
      identificacion: "Identificación",
      identificacionCampo: "identificacionCampo",
      usuarioModifica: "Usuario",
      accion: "Acción",
      eliminar: "Eliminar",
      editar: "Editar",
      noRemisiones: "No hay remisiones disponibles",
      totalRegistros: "Total registros: ",
    },
  },
  lineaUnicaModal: {
    mensajesAlerta: {
      exitoCambioDatosPaciente: "Novedad enviada a gestión exitosamente",
      errorCambioDatosPaciente: "Ha ocurrido un error, favor intente más tarde",
      errorCargarDatosPaciente:
        "Ha ocurrido un error al cargar los datos del paciente, favor intente más tarde",
    },
    campos: {
      identificacion: "Identificacón",
      novedad: "Crear novedad cambio de dirección",
      llamdaNocontestada: "Causas de la llamada",
      motivos: "Causas",
    },
    botones: {
      cancelar: "Cancelar",
      guardar: "Guardar",
    },
    tabla: {
      idProfesional: "Profesional",
      profesionalCampo: "idProfesional",
      fechaPrimerCitaCampo: "fechaPrimercita",
      fechaPrimercita: "Fecha inicio cita",
      fechaFinCitaCampo: "Fecha fin cita",
      fechaFinCita: "fechaFinCita",
      noCitas: "El paciente no tiene citas",
      visualizar: "Visualizar",
      especialista: "Especialista",
      especialistaCampo: "especialidad",
      totalRegistros: "Total registros: ",
    },
    errores: {
      noExitosa: "Debes seleccionar una causa",
    },
  },
  detalleVisita: {
    campos: {
      titulo: "Detalle visitas",
      procedimientos: "Procedimientos",
      tratamientos: "Tratamientos",
      curaciones: "Curaciones",
      sondaje: "Sondajes",
      tomaDeMuestra: "Toma de muestra",
      secreciones: "Secreciones",
      fotoTerapia: "Fototerapias",
      noHayDatos: "No hay visitas",
      soporteNutricional: "Soporte nutricional",
      canalizaciones: "Canalizaciones",
    },
    tabla: {
      procedimientos: {
        curaciones: {
          ubicacionHeridaCampo: "Ubicación herida",
          ubicacionHerida: "ubicacionHerida",
          tipoCuracion: "Tipo Curación",
          tipoCuracionCampo: "tipoCuracionDescripcion",
        },
        tomaDeMuestra: {
          tipoPrestacionCampo: "Toma de muestra",
          tipoPrestacion: "tipoPrestacion",
          fechaMuestraCampo: "Fecha muestra",
          fechaMuestra: "fechaMuestra",
          tipoMuestraCampo: "tipoMuestraDescripcion",
          tipoMuestra: "Tipo de muestra",
          requiereAyunoCampo: "Requiere ayuno",
          requiereAyuno: "requiereAyuno",
        },
        secreciones: {
          tipoPrestacion: "Tipo presentación",
          tipoPrestacionCampo: "tipoPrestacion",
          diasTratamientoCampo: "Dias tratamiento",
          diasTratamiento: "diasTratamiento",
          envioAspiradorCampo: "Envio aspirador",
          envioAspirador: "envioAspirador",
          visitaEnfermeriaCampo: "Visita enfermeria",
          visitaEnfermeria: "visitaEnfermeria",
          tipoSonda: "Tipo sonda",
          tipoSondaCampo: "tipoSonda",
          nasalCampo: "Nasal",
          nasal: "nasal",
          traqueostomiaCampo: "Traqueostomia",
        },
        canalizaciones: {
          tipoCanalziacion: "Tipo de canalización",
          tipoDeCanalizacionCampo: "canalizacion",
        },
        fototerapias: {
          tipoPrestacion: "Tipo Presentación",
          tipoPrestacionCampo: "tipoPrestacion",
          bilirrubinaTotal: "Bilirrubina total",
          bilirrubinaTotalCampo: "bilirrubinaTotal",
        },
        sondaje: {
          sondaje: "Sondaje",
          sondajeCampo: "sondaje",
          tipoPresentacion: "Tipo presentación",
          tipoPresentacionCampo: "tipoPresentacion",
          totalSesiones: "Total sesiones",
          totalSesionesCampo: "totalSesiones",
          fechaSondaje: "Fecha sondaje",
          fechaSondajeCampo: "fechaSondaje",
        },
        soporteNutricional: {
          nombreMedicamento: "Medicamento",
          nombreMedicamentoCampo: "medicamento",
          duracion: "Duración",
          duracionCampo: "duracion",
          tipoNutricion: "Tipo nutrición",
          tipoNutricionCampo: "tipoNutricion",
          nutricion: "Nutrición",
          nutricionCampo: "nutricion",
          dosis: "Dosis",
          dosisCampo: "dosis",
        },
      },

      tratamientos: {
        id: "id",
        medicamentoCampo: "medicamentoDescripcion",
        medicamento: "Medicamento",
        dosisCampo: "cantidadDosis",
        dosis: "Dosis",
        viaAdministracionCampo: "viaAdministracion",
        viaAdministracion: "Via administración",
        frecuenciaCampo: "frecuenciaDescripcion",
        frecuencia: "Frecuencia",
      },
      datosAtencion: {
        idProfesional: "Profesional",
        profesionalCampo: "idProfesional",
        nombreProfesional: "Nombre profesional",
        nombreProfesionalCampo: "nombreProfesional",
        piso: "Piso",
        pisoCampo: "piso",
        fechaInicioCita: "Hora inicio cita",
        horaInicioCampo: "fechaInicioCita",
        fechaFinCita: "Hora fin visita",
        horaFincampo: "fechaFinCita",
        noHayDatos: "No hay datos",
      },
    },
  },

  equiposBiomedicos: {
    gestionEquipos: {
      campos: {
        tipoDocumento: "Tipo documento",
        numeroDocumento: "Número documento",
        ciudad: "Ciudad",
        remision: "Remisión",
        estado: "Estado",
        usuario: "Usuario",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
        planesGestionados: "Mostrar planes de manejo gestionados",
      },
      errores: {
        ciudadRequerido: "Seleccione la ciudad",
        numeroDocumentoMaximaLongitud: "Máximo 20 caracteres",
        numeroDocumentoInvalido: "Número de documento inválido",
        remisionMaximaLongitud: "Máximo 15 caracteres",
        remisionInvalido: "Número de documento inválido",
        usuarioMaximaLongitud: "Máximo 15 caracteres",
        usuarioInvalido: "Número de documento inválido",
        fechaFinRequerido: "Ingresa la fecha",
      },
      tabla: {
        remisionCampo: "remision",
        remision: "Remision",
        nombrePacienteCampo: "paciente",
        nombrePaciente: "Paciente",
        equipoBiomedicoCampo: "equipoBiomedico",
        equipoBiomedico: "Equipo",
        fechaInicioCampo: "fechaInicio",
        fechaInicio: "Fecha inicio",
        fechaFinCampo: "fechaFin",
        fechaFin: "Fecha fin",
        estadoCampo: "estado",
        estado: "Estado",
        usuarioCampo: "usuario",
        usuario: "Usuario",
        fechaRegistroCampo: "fechaRegistro",
        fechaRegistro: "Fecha ultimo registro",
        accion: "Acción",
        gestionar: "Gestionar",
        visualizar: "Visualizar",
        planSaludCampoB: "planSalud",
        planSaludB: "Plan salud",
        ciudadCampo: "ciudad",
        ciudad: "Ciudad",
        noEquiposBiomedicos:
          "No se presentan equipos biomédicos relacionados a los criterios de búsqueda",
        totalRegistros: "Total registros: ",
      },
      titulos: {
        gestionarEquipos: "Gestionar equipos biomédicos",
      },
      botones: {
        limpiar: "Limpiar",
        buscar: "Buscar",
        guardarFiltros: "Guardar filtros",
      },
      mensajesAlerta: {
        errorEquiposBiomedicos: "Ha ocurrido un error, favor intente más tarde",
      },
      estados: {
        solicitado: "1",
        asignado: "2",
        entregado: "3",
        terminado: "4",
        cancelado: "5",
        devolucion_fallida: "13",
      },
    },

    detalleGestionEquipos: {
      campos: {
        remision: "Remisión",
        paciente: "Paciente",
        tipoDocumento: "Tipo documento",
        numeroDocumento: "Número documento",
        equipoBiomedico: "Equipo biomédico",
        viaAdministracion: "Via administracion",
        noTieneViaAdministracion: "No tiene via administracion",
        fechaRegistro: "Fecha registro",
        nivelIngreso: "Nivel de ingreso",
        direccion: "Dirección",
        direccionComplementaria: "Dirección complementaria",
        telefono: "Teléfono",
        planSalud: "Plan salud",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
        usuario: "Usuario",
        nota: "Escriba una nota",
        notas: "Notas",
        estado: "Estado",
        proveedor: "Proveedor",
      },
      titulos: {
        gestionEquipo: "Gestión equipo biomédico",
      },
      errores: {
        fechaInicioRequerido: "Ingrese fecha",
        fechaFinRequerido: "Ingrese fecha",
        estadoRequerido: "Seleccione el estado",
        proveedorRequerido: "Seleccione el proveedor",
        notaRequerido: "Ingrese nota",
        equipoRequerido: "Seleccione un equipo",
      },
      botones: {
        asignar: "Asignar",
        cancelar: "Cancelar",
        guardar: "Guardar",
      },
      mensajesAlerta: {
        tituloConfirmarCambioEstado: "Cambio de estado",
        contenidoConfirmarCambioEstado:
          "¿Está seguro de cambiar el estado del equipo biomédico?",
        exitoGestionarEquipo:
          "Se ha gestionado el equipo biomédico exitosamente",
        errorGestionarEquipo: "Ha ocurrido un error, favor intente más tarde",
      },
      mensajeAcceso: {
        titulo: "Acceso modulo biomédicos",
      },
    },
  },

  bebeCanguroAmbulatorio: {
    titulos: {
      subtitle: "Bebé canguro",
    },
    campos: {
      tipoDocumento: "Tipo documento",
      identificacion: "Identificación",
      remision: "Remisión",
      institucionRemitente: "Institución remitente",
      planSalud: "Plan de salud",
      estado: "Estado",
      ciudadPrincipal: "Ciudad principal",
      fechaInicio: "Fecha inicio",
    },
    errores: {
      tipoDocumentoRequerido: "Elige el documento",
      numeroMaximaLongitud: "Máximo 15 dígitos",
      numeroFormatoInvalido: "Número inválido",
    },
    botones: {
      buscar: "Buscar",
      limpiar: "Limpiar",
    },
    tabla: {
      idRemision: "idRemision",
      numeroRemisionCampo: "numeroRemision",
      numeroRemision: "Numero remisión",
      fechaRemisionCampo: "fechaRemision",
      fechaRemision: "Fecha remisión",
      nombrePacienteCampo: "nombrePaciente",
      nombrePaciente: "Paciente",
      planSaludCampo: "planSalud",
      planSalud: "Plan",
      estadoRemisionCampo: "estadoRemision",
      estadoRemision: "Estado",
      usuarioModificaCampo: "usuarioModifica",
      usuarioModifica: "Usuario",
      accion: "Acción",
      eliminar: "Eliminar",
      editar: "Editar",
      noRemisiones: "No se han agregado remisiones",
    },
  },
  remsionesMedicamentos: {
    titulos: {
      subtitle: "Aplicación de medicamentos",
    },
    campos: {
      tipoDocumento: "Tipo documento",
      identificacion: "Identificación",
      remision: "Remisión",
      institucionRemitente: "Institución remitente",
      planSalud: "Plan de salud",
      estado: "Estado",
      ciudadPrincipal: "Ciudad principal",
      fechaInicio: "Fecha inicio",
    },
    errores: {
      tipoDocumentoRequerido: "Elige el documento",
      numeroMaximaLongitud: "Máximo 15 dígitos",
      numeroFormatoInvalido: "Número inválido",
    },
    botones: {
      buscar: "Buscar",
      limpiar: "Limpiar",
    },
    tabla: {
      idRemision: "idRemision",
      numeroRemisionCampo: "numeroRemision",
      numeroRemision: "Numero remisión",
      fechaRemisionCampo: "fechaRemision",
      fechaRemision: "Fecha remisión",
      nombrePacienteCampo: "nombrePaciente",
      nombrePaciente: "Paciente",
      planSaludCampo: "planSalud",
      planSalud: "Plan",
      estadoRemisionCampo: "estadoRemision",
      estadoRemision: "Estado",
      usuarioModificaCampo: "usuarioModifica",
      usuarioModifica: "Usuario",
      accion: "Acción",
      eliminar: "Eliminar",
      editar: "Editar",
      noRemisiones: "No se han agregado remisiones",
    },
  },
  detalleRemisionMedicamentos: {
    campos: {
      tratamientos: "Medicamentos",
    },
    tabla: {
      id: "id",
      medicamentoCampo: "medicamentoDescripcion",
      medicamento: "Medicamento",
      dosisCampo: "cantidadDosis",
      dosis: "Dosis",
      viaAdministracionCampo: "viaAdministracion",
      viaAdministracion: "Via administración",
      frecuenciaCampo: "frecuenciaDescripcion",
      frecuencia: "Frecuencia",
    },
  },

  transporte: {
    informeVehicular: {
      campos: {
        especialidad: "Especialidad",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
      },
      errores: {
        especialidadRequerido: "Selecciona especialidad",
      },
      botones: {
        descargarInforme: "Descargar",
      },
      archivo: {
        nombre: "InformeVehicular",
      },
    },
  },

  informeProgramacion: {
    campos: {
      especialidad: "Especialidad",
      fechaInicio: "Fecha inicio",
      fechaFin: "Fecha fin",
    },
    errores: {
      especialidadRequerido: "Selecciona especialidad",
    },
    botones: {
      descargarInforme: "Descargar",
    },
    archivo: {
      nombre: "InformeVehicular",
    },
  },

  informesList: {
    campos: {
      especialidad: "Informe",
      fechaInicio: "Fecha inicio",
      fechaFin: "Fecha fin",
    },
    errores: {
      especialidadRequerido: "Selecciona un maestro",
    },
    botones: {
      descargarInforme: "Descargar",
    },
    archivo: {
      nombre: "Informe",
    },
    paliativos: {
      campos: {
        especialidad: "Especialidad",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
      },
      errores: {
        fechaFinRequerido: "Fecha fin es requerido",
      },
    },
  },
  errores: {
    cuatro01: "No estas autorizado para realizar esta operación",
    cuatro03: "No tienes permisos para acceder",
    cuatro04: "Ha ocurrido un error, favor intente más tarde",
    cinco00: "Ha ocurrido un error, favor intente más tarde",
  },

  informes: {
    informeRemisiones: {
      campos: {
        fechaInicio: "Fecha inicio",
      },
      tabla: {
        noEstados: "No se presentan estados disponibles",
        totalRegistros: "Total registros: ",
        estadoCampo: "estado",
        estado: "Estado",
      },
      errores: {
        fechaInicioRequerido: "Ingrese fecha",
        seleccionEstadoRequerido: "Seleccione al menos un estado a filtrar",
      },
      botones: {
        descargarInforme: "Descargar",
      },
      archivo: {
        nombre: "InformeRemisiones",
      },
      titulo: {
        tituloPantalla: "Informe remisiones",
      },
    },
    informeSeguridad: {
      boton: "Subir Archivo",
    },

    informeEgreso: {
      todosProgramas: "Todos",
      todasCiudades: "Todas",
      ciudad: "Ciudad",
      programa: "Programa",
      piso: "Piso",
      fechaInicio: "Fecha Inicial",
      fechaFin: "Fecha Final",
      botones: {
        descargarInforme: "Descargar Informe",
      },
      tipoAtencion: {
        domiciliario: "Domiciliario",
        ambulatorio: "Ambulatorio",
      },
      errores: {
        ciudadRequerida: "Debe seleccionar una ciudad",
      },
    },

    informeTrasladoPiso: {
      todosProgramas: "Todos",
      todasCiudades: "Todas",
      ciudad: "Ciudad",
      programa: "Programa",
      piso: "Piso",
      fechaInicio: "Fecha Inicial",
      fechaFin: "Fecha Final",
      botones: {
        descargarInforme: "Descargar Informe",
      },
      tipoAtencion: {
        domiciliario: "Domiciliario",
        ambulatorio: "Ambulatorio",
      },
      errores: {
        ciudadRequerida: "Debe seleccionar una ciudad",
      },
    },

    informePácientes: {
      todosProgramas: "TODOS",
      todasCiudades: "TODAS",
      ciudad: "Ciudad",
      programa: "Programa",
      piso: "Piso",
      botones: {
        descargarInforme: "Descargar Informe",
      },
      errores: {
        ciudadRequerida: "Debe seleccionar una ciudad",
      },
    },
    informeEquiposBiomedicos: {
      todosProgramas: "Todos",
      estado: "Estado",
      fechaInicio: "Fecha Inicial",
      fechaFin: "Fecha Final",
      planSalud: "Plan de salud",
      botones: {
        descargarInforme: "Descargar Informe",
      },
      tipoAtencion: {
        domiciliario: "Domiciliario",
        ambulatorio: "Ambulatorio",
      },
      errores: {
        ciudadRequerida: "Debe seleccionar una ciudad",
      },
    },
    informeCuraciones: {
      todosProgramas: "Todos",
      ciudad: "Ciudad",
      programa: "Programa",
      piso: "Piso",
      fechaInicio: "Fecha Inicial",
      fechaFin: "Fecha Final",
      botones: {
        descargarInforme: "Descargar Informe",
      },
      tipoAtencion: {
        domiciliario: "Domiciliario",
        ambulatorio: "Ambulatorio",
      },
      errores: {
        ciudadRequerida: "Debe seleccionar una ciudad",
      },
    },

    informeProgramacion: {
      campos: {
        especialidad: "Especialidad",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
        ciudad: "Ciudad",
      },
      errores: {
        especialidadRequerido: "Selecciona especialidad",
        ciudadRequerido: "Seleccione ciudad",
      },
      botones: {
        descargarInforme: "Descargar",
      },

      archivo: {
        nombre: "InformeVehicular",
      },
    },

    informeCenso: {
      campos: {
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
        ciudad: "Ciudad",
      },
      errores: {
        fechaInicioRequerido: "Ingrese fecha",
        fechaFinRequerido: "Ingrese fecha",
      },
      botones: {
        descargarInforme: "Descargar Informe",
        limpiar: "Limpiar",
      },
      archivo: {
        nombre: "InformeCenso",
      },
    },

    informePager: {
      campos: {
        fechaNotificacion: "Fecha Notificación",
        tipoNotificacion: "Tipo Notificación",
      },
      errores: {
        fechaRequerido: "Ingrese fecha",
      },
      botones: {
        descargarInforme: "Descargar Informe",
        limpiar: "Limpiar",
      },
      archivo: {
        nombre: "InformeNotificacionesPager",
      },
    },

    informeTurno: {
      todasCiudades: "Todas",
      ciudad: "Ciudad",
      fechaInicio: "Fecha Inicial",
      fechaFin: "Fecha Final",
      botones: {
        descargarInforme: "Descargar Informe",
      },
      errores: {
        ciudadRequerida: "Debe seleccionar una ciudad",
      },
    },
  },

  bandejaDinamica: {
    gestionBandejaDinamica: {
      campos: {
        tipoDocumento: "Tipo documento",
        numeroDocumento: "Número documento",
        ciudad: "Ciudad",
        remision: "Remisión",
        estado: "Estado",
        usuario: "Usuario",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
      },
      errores: {
        ciudadRequerido: "Seleccione la ciudad",
        numeroDocumentoMaximaLongitud: "Máximo 20 caracteres",
        numeroDocumentoInvalido: "Número de documento inválido",
        remisionMaximaLongitud: "Máximo 15 caracteres",
        remisionInvalido: "Número de documento inválido",
        usuarioMaximaLongitud: "Máximo 15 caracteres",
        usuarioInvalido: "Número de documento inválido",
        fechaInicioRequerido: "Ingrese fecha inicio",
        fechaFinRequerido: "Ingrese fecha fin",
      },
      tabla: {
        nombrePacienteCampo: "nombrePaciente",
        nombrePaciente: "Nombre paciente",
        identificacionCampo: "numeroIdentificacion",
        identificacion: "Identificación",
        laboratorioCampo: "laboratorio",
        laboratorio: "Laboratorio",
        fechaSolicitudCampo: "fechaSolicitud",
        fechaSolicitud: "Fecha solicitud",
        fechaTomaMuestraCampo: "fechaTomaMuestra",
        fechaTomaMuestra: "Fecha toma muestra",
        usuarioSolicitudCampo: "usuarioSolicita",
        usuarioSolicitud: "Usuario solicitud",
        estadoSolicitudCampo: "estadoSolicitud",
        estadoSolicitud: "Estado solicitud",
        accion: "Acción",
        detalle: "Ver Detalle",
        noAyudasDiagnosticas:
          "No se presentan ayudas diagnósticas relacionadas a los criterios de búsqueda",
        totalRegistros: "Total registros: ",
      },
      titulos: {
        gestionarBandejaDinamica: "Historial y Gestión",
      },
      botones: {
        limpiar: "Limpiar",
        buscar: "Buscar",
        guardarFiltros: "Guardar filtros",
        gestionar: "Gestionar",
      },
      mensajesAlerta: {
        errorBandejaDinamica: "Ha ocurrido un error, favor intente más tarde",
        tituloGestionarBandejaDinamica: "Gestión de ayudas diagnósticas",
        contenidoGestionarBandejaDinamica:
          "¿Se gestionarán los registros seleccionados y se generará un maestro con el detalle de las ayudas diagnósticas a procesar?",
        exitoGestionBandejaDinamica:
          "Se han gestionado los registros exitósamente",
      },
    },

    detalleGestionBandejaDinamica: {
      campos: {
        nombreCompleto: "Nombre completo",
        tipoDocumento: "Tipo documento",
        numeroDocumento: "Número documento",
        equipoBiomedico: "Equipo biomédico",
        genero: "Genero",
        direccion: "Dirección",
        barrio: "Barrio",
        telefonoContacto: "Teléfono contácto",
        laboratorio: "Laboratorio",
        medicoSolicita: "Médico solicita",
        fechaSolicitud: "Fecha solicitud",
        fechaProgramacion: "Fecha programación",
        usuarioSolicita: "Usuario solicita",
      },
      titulos: {
        detalleAyudaDiagnostica: "Detalle ayuda diagnóstica",
      },
      errores: {
        fechaInicioRequerido: "Ingrese fecha",
        fechaFinRequerido: "Ingrese fecha",
        estadoRequerido: "Seleccione el estado",
        proveedorRequerido: "Seleccione el proveedor",
        notaRequerido: "Ingrese nota",
      },
      botones: {
        cerrar: "Cerrar",
      },
    },
  },
};
